import React from 'react';
import axios from 'axios';
import { render, screen, fireEvent, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import Index from './index';

jest.mock('axios');

// jdomにないため追加
window.HTMLElement.prototype.scrollTo = jest.fn();
window.AjaxZip3 = jest.fn();
window.AjaxZip3.zip2addr = jest.fn();

describe('Input(String) Test', () => {   
  test('Render', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[]}
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(string)_タイトル",
                shortTitle: "input(string)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(string)_description",
                    displayLeft: "input(string)_displayLeft",
                    displayName: "input(string)_displayName",
                    displayRight: "input(string)_displayRight",
                    fieldDefaultValue: "input(string)_fieldDefaultValue",
                    formName: "input",
                    placeholder: "input(string)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(string)_short2", 
                template_id: 1, 
                title: "input(string)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(string)_description2",
                    displayLeft: "input(string)_displayLeft2",
                    displayName: "input(string)_displayName2",
                    displayRight: "input(string)_displayRight2",
                    fieldDefaultValue: "input(string)_fieldDefaultValue2",
                    formName: "input",
                    placeholder: "input(string)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(string)_タイトル",
                shortTitle: "input(string)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(string)_description",
                    displayLeft: "input(string)_displayLeft",
                    displayName: "input(string)_displayName",
                    displayRight: "input(string)_displayRight",
                    fieldDefaultValue: "input(string)_fieldDefaultValue",
                    formName: "input",
                    placeholder: "input(string)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(string)_short2", 
                template_id: 1, 
                title: "input(string)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(string)_description2",
                    displayLeft: "input(string)_displayLeft2",
                    displayName: "input(string)_displayName2",
                    displayRight: "input(string)_displayRight2",
                    fieldDefaultValue: "input(string)_fieldDefaultValue2",
                    formName: "input",
                    placeholder: "input(string)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.input(string)_タイトル"})).toBeInTheDocument();
    expect(screen.getByText('input(string)_displayName')).toBeInTheDocument();
    expect(screen.getAllByText('input(string)_displayLeft')[0]).toBeInTheDocument();
    expect(screen.getAllByText('input(string)_displayRight')[0]).toBeInTheDocument();

    // field
    const textbox2 = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    expect(textbox2.value ).toBe('input(string)_fieldDefaultValue');
    expect(textbox2.placeholder).toBe('input(string)_placeholder');
    expect(textbox2.type).toBe('text');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Back Question', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(string)_タイトル",
                shortTitle: "input(string)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(string)_description",
                    displayLeft: "input(string)_displayLeft",
                    displayName: "input(string)_displayName",
                    displayRight: "input(string)_displayRight",
                    fieldDefaultValue: "input(string)_fieldDefaultValue",
                    formName: "input",
                    placeholder: "input(string)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(string)_short2", 
                template_id: 1, 
                title: "input(string)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(string)_description2",
                    displayLeft: "input(string)_displayLeft2",
                    displayName: "input(string)_displayName2",
                    displayRight: "input(string)_displayRight2",
                    fieldDefaultValue: "input(string)_fieldDefaultValue2",
                    formName: "input",
                    placeholder: "input(string)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(string)_タイトル",
                shortTitle: "input(string)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(string)_description",
                    displayLeft: "input(string)_displayLeft",
                    displayName: "input(string)_displayName",
                    displayRight: "input(string)_displayRight",
                    fieldDefaultValue: "input(string)_fieldDefaultValue",
                    formName: "input",
                    placeholder: "input(string)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(string)_short2", 
                template_id: 1, 
                title: "input(string)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(string)_description2",
                    displayLeft: "input(string)_displayLeft2",
                    displayName: "input(string)_displayName2",
                    displayRight: "input(string)_displayRight2",
                    fieldDefaultValue: "input(string)_fieldDefaultValue2",
                    formName: "input",
                    placeholder: "input(string)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const inputValue = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: 'TEST'}})
    inputValue.blur();
    expect(inputValue.value).toBe('TEST');

    

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(2/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.input(string)_タイトル2"})).toBeInTheDocument();
    expect(screen.getByText('input(string)_displayName2')).toBeInTheDocument();

    // main
    expect(screen.getAllByText('input(string)_displayLeft2')[0]).toBeInTheDocument();
    expect(screen.getAllByText('input(string)_displayRight2')[0]).toBeInTheDocument();

    // field
    const textbox2_2 = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    expect(textbox2_2.value).toBe('input(string)_fieldDefaultValue2');
    expect(textbox2_2.placeholder).toBe('input(string)_placeholder2');
    expect(textbox2_2.type).toBe('text');

    // button
    expect(screen.queryAllByText('戻る')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const backButton2 = screen.queryAllByText('戻る')[0];
    fireEvent.click(backButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.input(string)_タイトル"})).toBeInTheDocument();
    expect(screen.getByText('input(string)_displayName')).toBeInTheDocument();

    // main
    expect(screen.getAllByText('input(string)_displayLeft')[0]).toBeInTheDocument();
    expect(screen.getAllByText('input(string)_displayRight')[0]).toBeInTheDocument();

    // field
    const textbox2 = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;;
    expect(textbox2.value).toBe('TEST');
    expect(textbox2.placeholder).toBe('input(string)_placeholder');
    expect(textbox2.type).toBe('text');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Confirmation', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(string)_タイトル",
                shortTitle: "input(string)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(string)_description",
                    displayLeft: "input(string)_displayLeft",
                    displayName: "input(string)_displayName",
                    displayRight: "input(string)_displayRight",
                    fieldDefaultValue: "input(string)_fieldDefaultValue",
                    formName: "input",
                    placeholder: "input(string)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(string)_short2", 
                template_id: 1, 
                title: "input(string)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(string)_description2",
                    displayLeft: "input(string)_displayLeft2",
                    displayName: "input(string)_displayName2",
                    displayRight: "input(string)_displayRight2",
                    fieldDefaultValue: "input(string)_fieldDefaultValue2",
                    formName: "input",
                    placeholder: "input(string)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(string)_タイトル",
                shortTitle: "input(string)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(string)_description",
                    displayLeft: "input(string)_displayLeft",
                    displayName: "input(string)_displayName",
                    displayRight: "input(string)_displayRight",
                    fieldDefaultValue: "input(string)_fieldDefaultValue",
                    formName: "input",
                    placeholder: "input(string)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(string)_short2", 
                template_id: 1, 
                title: "input(string)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(string)_description2",
                    displayLeft: "input(string)_displayLeft2",
                    displayName: "input(string)_displayName2",
                    displayRight: "input(string)_displayRight2",
                    fieldDefaultValue: "input(string)_fieldDefaultValue2",
                    formName: "input",
                    placeholder: "input(string)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const inputValue = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: 'TEST'}})
    inputValue.blur();
    expect(inputValue.value).toBe('TEST');

    const nextButton1 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton1);

    const inputValue2 = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    inputValue2.focus();
    fireEvent.change(inputValue2, {target: {value: 'TEST2'}})
    inputValue2.blur();
    expect(inputValue2.value).toBe('TEST2');

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'input(string)_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'input(string)_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'TEST'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'TEST2'})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();

    // 編集ボタン
    const editButton = screen.getByRole('link', {name: 'input(string)_short'} );
    fireEvent.click(editButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.input(string)_タイトル"})).toBeInTheDocument();
    expect(screen.getByText('input(string)_displayName')).toBeInTheDocument();
    expect(screen.getAllByText('input(string)_displayLeft')[0]).toBeInTheDocument();
    expect(screen.getAllByText('input(string)_displayRight')[0]).toBeInTheDocument();

    // field
    const textbox2 = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    expect(textbox2.value ).toBe('TEST');
    expect(textbox2.placeholder).toBe('input(string)_placeholder');
    expect(textbox2.type).toBe('text');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.getAllByText('確認画面へ')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const editInputValue = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    editInputValue.focus();
    fireEvent.change(editInputValue, {target: {value: 'EditTEST'}})
    editInputValue.blur();
    expect(editInputValue.value).toBe('EditTEST');

    // 編集ボタン
    const confirmationButton = screen.getAllByText('確認画面へ')[0];
    fireEvent.click(confirmationButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'input(string)_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'input(string)_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'EditTEST'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'TEST2'})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();
  });    
});

describe('Input(Integer)) Test', () => { 
  test('Render', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(integer)_タイトル",
                shortTitle: "input(integer)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(integer)_description",
                    displayLeft: "input(integer)_displayLeft",
                    displayName: "input(integer)_displayName",
                    displayRight: "input(integer)_displayRight",
                    fieldDefaultValue: "22222",
                    formName: "input_integer",
                    placeholder: "input(integer)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(integer)_short2", 
                template_id: 1, 
                title: "input(integer)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(integer)_description2",
                    displayLeft: "input(integer)_displayLeft2",
                    displayName: "input(integer)_displayName2",
                    displayRight: "input(integer)_displayRight2",
                    fieldDefaultValue: "11111",
                    formName: "input_integer",
                    placeholder: "input(integer)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(integer)_タイトル",
                shortTitle: "input(integer)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(integer)_description",
                    displayLeft: "input(integer)_displayLeft",
                    displayName: "input(integer)_displayName",
                    displayRight: "input(integer)_displayRight",
                    fieldDefaultValue: "22222",
                    formName: "input_integer",
                    placeholder: "input(integer)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(integer)_short2", 
                template_id: 1, 
                title: "input(integer)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(integer)_description2",
                    displayLeft: "input(integer)_displayLeft2",
                    displayName: "input(integer)_displayName2",
                    displayRight: "input(integer)_displayRight2",
                    fieldDefaultValue: "11111",
                    formName: "input_integer",
                    placeholder: "input(integer)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.input(integer)_タイトル"})).toBeInTheDocument();
    expect(screen.getAllByText('input(integer)_displayLeft')[0]).toBeInTheDocument();
    expect(screen.getAllByText('input(integer)_displayRight')[0]).toBeInTheDocument();

    // field
    const spinbutton2 = screen.getByRole('spinbutton', {name: ""}) as HTMLInputElement;
    expect(spinbutton2.value ).toBe('22222');
    expect(spinbutton2.placeholder).toBe('input(integer)_placeholder');
    expect(spinbutton2.type).toBe('number');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Back Question', async() => {

    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(integer)_タイトル",
                shortTitle: "input(integer)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(integer)_description",
                    displayLeft: "input(integer)_displayLeft",
                    displayName: "input(integer)_displayName",
                    displayRight: "input(integer)_displayRight",
                    fieldDefaultValue: "22222",
                    formName: "input_integer",
                    placeholder: "input(integer)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(integer)_short2", 
                template_id: 1, 
                title: "input(integer)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(integer)_description2",
                    displayLeft: "input(integer)_displayLeft2",
                    displayName: "input(integer)_displayName2",
                    displayRight: "input(integer)_displayRight2",
                    fieldDefaultValue: "11111",
                    formName: "input_integer",
                    placeholder: "input(integer)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(integer)_タイトル",
                shortTitle: "input(integer)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(integer)_description",
                    displayLeft: "input(integer)_displayLeft",
                    displayName: "input(integer)_displayName",
                    displayRight: "input(integer)_displayRight",
                    fieldDefaultValue: "22222",
                    formName: "input_integer",
                    placeholder: "input(integer)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(integer)_short2", 
                template_id: 1, 
                title: "input(integer)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(integer)_description2",
                    displayLeft: "input(integer)_displayLeft2",
                    displayName: "input(integer)_displayName2",
                    displayRight: "input(integer)_displayRight2",
                    fieldDefaultValue: "11111",
                    formName: "input_integer",
                    placeholder: "input(integer)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);
    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const inputValue = screen.getByRole('spinbutton', {name: ""}) as HTMLInputElement;
    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: 1234}})
    inputValue.blur();
    expect(inputValue.value).toBe("1234");

    

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(2/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.input(integer)_タイトル2"})).toBeInTheDocument();

    // main
    expect(screen.getAllByText('input(integer)_displayLeft2')[0]).toBeInTheDocument();
    expect(screen.getAllByText('input(integer)_displayRight2')[0]).toBeInTheDocument();

    // field
    const spinbutton2_2 = screen.getByRole('spinbutton', {name: ""}) as HTMLInputElement;
    expect(spinbutton2_2.value).toBe('11111');
    expect(spinbutton2_2.placeholder).toBe('input(integer)_placeholder2');
    expect(spinbutton2_2.type).toBe('number');

    // button
    expect(screen.queryAllByText('戻る')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const backButton2 = screen.queryAllByText('戻る')[0];
    fireEvent.click(backButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.input(integer)_タイトル"})).toBeInTheDocument();

    // main
    expect(screen.getAllByText('input(integer)_displayLeft')[0]).toBeInTheDocument();
    expect(screen.getAllByText('input(integer)_displayRight')[0]).toBeInTheDocument();

    // field
    const spinbutton2 = screen.getByRole('spinbutton', {name: ""}) as HTMLInputElement;;
    expect(spinbutton2.value).toBe("1234");
    expect(spinbutton2.placeholder).toBe('input(integer)_placeholder');
    expect(spinbutton2.type).toBe('number');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Confirmation', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(integer)_タイトル",
                shortTitle: "input(integer)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(integer)_description",
                    displayLeft: "input(integer)_displayLeft",
                    displayName: "input(integer)_displayName",
                    displayRight: "input(integer)_displayRight",
                    fieldDefaultValue: "22222",
                    formName: "input_integer",
                    placeholder: "input(integer)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(integer)_short2", 
                template_id: 1, 
                title: "input(integer)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(integer)_description2",
                    displayLeft: "input(integer)_displayLeft2",
                    displayName: "input(integer)_displayName2",
                    displayRight: "input(integer)_displayRight2",
                    fieldDefaultValue: "11111",
                    formName: "input_integer",
                    placeholder: "input(integer)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(integer)_タイトル",
                shortTitle: "input(integer)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(integer)_description",
                    displayLeft: "input(integer)_displayLeft",
                    displayName: "input(integer)_displayName",
                    displayRight: "input(integer)_displayRight",
                    fieldDefaultValue: "22222",
                    formName: "input_integer",
                    placeholder: "input(integer)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(integer)_short2", 
                template_id: 1, 
                title: "input(integer)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(integer)_description2",
                    displayLeft: "input(integer)_displayLeft2",
                    displayName: "input(integer)_displayName2",
                    displayRight: "input(integer)_displayRight2",
                    fieldDefaultValue: "11111",
                    formName: "input_integer",
                    placeholder: "input(integer)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const inputValue = screen.getByRole('spinbutton', {name: ""}) as HTMLInputElement;
    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: 1234}})
    inputValue.blur();
    expect(inputValue.value).toBe("1234");

    const nextButton1 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton1);

    const inputValue2 = screen.getByRole('spinbutton', {name: ""}) as HTMLInputElement;
    inputValue2.focus();
    fireEvent.change(inputValue2, {target: {value: 5678}})
    inputValue2.blur();
    expect(inputValue2.value).toBe("5678");

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'input(integer)_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'input(integer)_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: '1234'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '5678'})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();

    // 編集ボタン
    const editButton = screen.getByRole('link', {name: 'input(integer)_short'} );
    fireEvent.click(editButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.input(integer)_タイトル"})).toBeInTheDocument();
    expect(screen.getAllByText('input(integer)_displayLeft')[0]).toBeInTheDocument();
    expect(screen.getAllByText('input(integer)_displayRight')[0]).toBeInTheDocument();

    // field
    const spinbutton2 = screen.getByRole('spinbutton', {name: ""}) as HTMLInputElement;
    expect(spinbutton2.value ).toBe("1234");
    expect(spinbutton2.placeholder).toBe('input(integer)_placeholder');
    expect(spinbutton2.type).toBe('number');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.getAllByText('確認画面へ')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const editInputValue = screen.getByRole('spinbutton', {name: ""}) as HTMLInputElement;
    editInputValue.focus();
    fireEvent.change(editInputValue, {target: {value: 112233}})
    editInputValue.blur();
    expect(editInputValue.value).toBe("112233");

    // 編集ボタン
    const confirmationButton = screen.getAllByText('確認画面へ')[0];
    fireEvent.click(confirmationButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'input(integer)_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'input(integer)_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: '112233'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '5678'})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();
  });    

  test('Validation Check', async() => {
    global.alert = jest.fn()

    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(integer)_タイトル",
                shortTitle: "input(integer)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(integer)_description",
                    displayLeft: "input(integer)_displayLeft",
                    displayName: "input(integer)_displayName",
                    displayRight: "input(integer)_displayRight",
                    fieldDefaultValue: "22222",
                    formName: "input_integer",
                    placeholder: "input(integer)_placeholder",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(integer)_short2", 
                template_id: 1, 
                title: "input(integer)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(integer)_description2",
                    displayLeft: "input(integer)_displayLeft2",
                    displayName: "input(integer)_displayName2",
                    displayRight: "input(integer)_displayRight2",
                    fieldDefaultValue: "11111",
                    formName: "input_integer",
                    placeholder: "input(integer)_placeholder2",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(integer)_タイトル",
                shortTitle: "input(integer)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(integer)_description",
                    displayLeft: "input(integer)_displayLeft",
                    displayName: "input(integer)_displayName",
                    displayRight: "input(integer)_displayRight",
                    fieldDefaultValue: "22222",
                    formName: "input_integer",
                    placeholder: "input(integer)_placeholder",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(integer)_short2", 
                template_id: 1, 
                title: "input(integer)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(integer)_description2",
                    displayLeft: "input(integer)_displayLeft2",
                    displayName: "input(integer)_displayName2",
                    displayRight: "input(integer)_displayRight2",
                    fieldDefaultValue: "11111",
                    formName: "input_integer",
                    placeholder: "input(integer)_placeholder2",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);
    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const inputValue = screen.getByRole('spinbutton', {name: ""}) as HTMLInputElement;

    // 最大値999、最小値0を設定
    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: 1000}})
    inputValue.blur();
    expect(global.alert).toHaveBeenCalledTimes(1);
    expect(inputValue.value).toBe('');

    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: 999}})
    inputValue.blur();
    expect(global.alert).toHaveBeenCalledTimes(1); // 範囲内の数値を入力した場合はインクリメントされないことを確認
    expect(inputValue.value).toBe('999');

    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: -1}})
    inputValue.blur();
    expect(global.alert).toHaveBeenCalledTimes(2);
    expect(inputValue.value).toBe('');

    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: 0}})
    inputValue.blur();
    expect(global.alert).toHaveBeenCalledTimes(2); // 範囲内の数値を入力した場合はインクリメントされないことを確認
    expect(inputValue.value).toBe('0');
  });
});

describe('Input(decimal)) Test', () => {    
  test('Render', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(decimal)_タイトル",
                shortTitle: "input(decimal)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(decimal)_description",
                    displayLeft: "input(decimal)_displayLeft",
                    displayName: "input(decimal)_displayName",
                    displayRight: "input(decimal)_displayRight",
                    fieldDefaultValue: "1.11",
                    formName: "input_decimal",
                    placeholder: "input(decimal)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(decimal)_short2", 
                template_id: 1, 
                title: "input(decimal)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(decimal)_description2",
                    displayLeft: "input(decimal)_displayLeft2",
                    displayName: "input(decimal)_displayName2",
                    displayRight: "input(decimal)_displayRight2",
                    fieldDefaultValue: "2.22",
                    formName: "input_decimal",
                    placeholder: "input(decimal)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(decimal)_タイトル",
                shortTitle: "input(decimal)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(decimal)_description",
                    displayLeft: "input(decimal)_displayLeft",
                    displayName: "input(decimal)_displayName",
                    displayRight: "input(decimal)_displayRight",
                    fieldDefaultValue: "1.11",
                    formName: "input_decimal",
                    placeholder: "input(decimal)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(decimal)_short2", 
                template_id: 1, 
                title: "input(decimal)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(decimal)_description2",
                    displayLeft: "input(decimal)_displayLeft2",
                    displayName: "input(decimal)_displayName2",
                    displayRight: "input(decimal)_displayRight2",
                    fieldDefaultValue: "2.22",
                    formName: "input_decimal",
                    placeholder: "input(decimal)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.input(decimal)_タイトル"})).toBeInTheDocument();
    expect(screen.getAllByText('input(decimal)_displayLeft')[0]).toBeInTheDocument();
    expect(screen.getAllByText('input(decimal)_displayRight')[0]).toBeInTheDocument();

    // field
    const spinbutton2 = screen.getByRole('spinbutton', {name: ""}) as HTMLInputElement;
    expect(spinbutton2.value ).toBe('1.11');
    expect(spinbutton2.placeholder).toBe('input(decimal)_placeholder');
    expect(spinbutton2.type).toBe('number');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Back Question', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(decimal)_タイトル",
                shortTitle: "input(decimal)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(decimal)_description",
                    displayLeft: "input(decimal)_displayLeft",
                    displayName: "input(decimal)_displayName",
                    displayRight: "input(decimal)_displayRight",
                    fieldDefaultValue: "1.11",
                    formName: "input_decimal",
                    placeholder: "input(decimal)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(decimal)_short2", 
                template_id: 1, 
                title: "input(decimal)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(decimal)_description2",
                    displayLeft: "input(decimal)_displayLeft2",
                    displayName: "input(decimal)_displayName2",
                    displayRight: "input(decimal)_displayRight2",
                    fieldDefaultValue: "2.22",
                    formName: "input_decimal",
                    placeholder: "input(decimal)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(decimal)_タイトル",
                shortTitle: "input(decimal)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(decimal)_description",
                    displayLeft: "input(decimal)_displayLeft",
                    displayName: "input(decimal)_displayName",
                    displayRight: "input(decimal)_displayRight",
                    fieldDefaultValue: "1.11",
                    formName: "input_decimal",
                    placeholder: "input(decimal)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(decimal)_short2", 
                template_id: 1, 
                title: "input(decimal)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(decimal)_description2",
                    displayLeft: "input(decimal)_displayLeft2",
                    displayName: "input(decimal)_displayName2",
                    displayRight: "input(decimal)_displayRight2",
                    fieldDefaultValue: "2.22",
                    formName: "input_decimal",
                    placeholder: "input(decimal)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const inputValue = screen.getByRole('spinbutton', {name: ""}) as HTMLInputElement;
    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: 1234}})
    inputValue.blur();
    expect(inputValue.value).toBe("1234");

    

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(2/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.input(decimal)_タイトル2"})).toBeInTheDocument();

    // main
    expect(screen.getAllByText('input(decimal)_displayLeft2')[0]).toBeInTheDocument();
    expect(screen.getAllByText('input(decimal)_displayRight2')[0]).toBeInTheDocument();

    // field
    const spinbutton2_2 = screen.getByRole('spinbutton', {name: ""}) as HTMLInputElement;
    expect(spinbutton2_2.value).toBe('2.22');
    expect(spinbutton2_2.placeholder).toBe('input(decimal)_placeholder2');
    expect(spinbutton2_2.type).toBe('number');

    // button
    expect(screen.queryAllByText('戻る')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const backButton2 = screen.queryAllByText('戻る')[0];
    fireEvent.click(backButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.input(decimal)_タイトル"})).toBeInTheDocument();

    // main
    expect(screen.getAllByText('input(decimal)_displayLeft')[0]).toBeInTheDocument();
    expect(screen.getAllByText('input(decimal)_displayRight')[0]).toBeInTheDocument();

    // field
    const spinbutton2 = screen.getByRole('spinbutton', {name: ""}) as HTMLInputElement;;
    expect(spinbutton2.value).toBe("1234");
    expect(spinbutton2.placeholder).toBe('input(decimal)_placeholder');
    expect(spinbutton2.type).toBe('number');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Confirmation', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(decimal)_タイトル",
                shortTitle: "input(decimal)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(decimal)_description",
                    displayLeft: "input(decimal)_displayLeft",
                    displayName: "input(decimal)_displayName",
                    displayRight: "input(decimal)_displayRight",
                    fieldDefaultValue: "1.11",
                    formName: "input_decimal",
                    placeholder: "input(decimal)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(decimal)_short2", 
                template_id: 1, 
                title: "input(decimal)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(decimal)_description2",
                    displayLeft: "input(decimal)_displayLeft2",
                    displayName: "input(decimal)_displayName2",
                    displayRight: "input(decimal)_displayRight2",
                    fieldDefaultValue: "2.22",
                    formName: "input_decimal",
                    placeholder: "input(decimal)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(decimal)_タイトル",
                shortTitle: "input(decimal)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(decimal)_description",
                    displayLeft: "input(decimal)_displayLeft",
                    displayName: "input(decimal)_displayName",
                    displayRight: "input(decimal)_displayRight",
                    fieldDefaultValue: "1.11",
                    formName: "input_decimal",
                    placeholder: "input(decimal)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(decimal)_short2", 
                template_id: 1, 
                title: "input(decimal)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(decimal)_description2",
                    displayLeft: "input(decimal)_displayLeft2",
                    displayName: "input(decimal)_displayName2",
                    displayRight: "input(decimal)_displayRight2",
                    fieldDefaultValue: "2.22",
                    formName: "input_decimal",
                    placeholder: "input(decimal)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const inputValue = screen.getByRole('spinbutton', {name: ""}) as HTMLInputElement;
    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: 1.23}})
    inputValue.blur();
    expect(inputValue.value).toBe("1.23");

    const nextButton1 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton1);

    const inputValue2 = screen.getByRole('spinbutton', {name: ""}) as HTMLInputElement;
    inputValue2.focus();
    fireEvent.change(inputValue2, {target: {value: 4.56}})
    inputValue2.blur();
    expect(inputValue2.value).toBe("4.56");

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'input(decimal)_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'input(decimal)_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: '1.23'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '4.56'})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();

    // 編集ボタン
    const editButton = screen.getByRole('link', {name: 'input(decimal)_short'} );
    fireEvent.click(editButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.input(decimal)_タイトル"})).toBeInTheDocument();
    expect(screen.getAllByText('input(decimal)_displayLeft')[0]).toBeInTheDocument();
    expect(screen.getAllByText('input(decimal)_displayRight')[0]).toBeInTheDocument();

    // field
    const spinbutton2 = screen.getByRole('spinbutton', {name: ""}) as HTMLInputElement;
    expect(spinbutton2.value ).toBe("1.23");
    expect(spinbutton2.placeholder).toBe('input(decimal)_placeholder');
    expect(spinbutton2.type).toBe('number');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.getAllByText('確認画面へ')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const editInputValue = screen.getByRole('spinbutton', {name: ""}) as HTMLInputElement;
    editInputValue.focus();
    fireEvent.change(editInputValue, {target: {value: 10.1}})
    editInputValue.blur();
    expect(editInputValue.value).toBe("10.1");

    // 編集ボタン
    const confirmationButton = screen.getAllByText('確認画面へ')[0];
    fireEvent.click(confirmationButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'input(decimal)_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'input(decimal)_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: '10.1'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '4.56'})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();
  });  
  
  test('Validation Check', async() => {
    global.alert = jest.fn();

    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(decimal)_タイトル",
                shortTitle: "input(decimal)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(decimal)_description",
                    displayLeft: "input(decimal)_displayLeft",
                    displayName: "input(decimal)_displayName",
                    displayRight: "input(decimal)_displayRight",
                    fieldDefaultValue: "1.11",
                    formName: "input_decimal",
                    placeholder: "input(decimal)_placeholder",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(decimal)_short2", 
                template_id: 1, 
                title: "input(decimal)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(decimal)_description2",
                    displayLeft: "input(decimal)_displayLeft2",
                    displayName: "input(decimal)_displayName2",
                    displayRight: "input(decimal)_displayRight2",
                    fieldDefaultValue: "2.22",
                    formName: "input_decimal",
                    placeholder: "input(decimal)_placeholder2",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(decimal)_タイトル",
                shortTitle: "input(decimal)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(decimal)_description",
                    displayLeft: "input(decimal)_displayLeft",
                    displayName: "input(decimal)_displayName",
                    displayRight: "input(decimal)_displayRight",
                    fieldDefaultValue: "1.11",
                    formName: "input_decimal",
                    placeholder: "input(decimal)_placeholder",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(decimal)_short2", 
                template_id: 1, 
                title: "input(decimal)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(decimal)_description2",
                    displayLeft: "input(decimal)_displayLeft2",
                    displayName: "input(decimal)_displayName2",
                    displayRight: "input(decimal)_displayRight2",
                    fieldDefaultValue: "2.22",
                    formName: "input_decimal",
                    placeholder: "input(decimal)_placeholder2",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const inputValue = screen.getByRole('spinbutton', {name: ""}) as HTMLInputElement;

    // 最大値999、最小値0を設定
    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: 1000}})
    inputValue.blur();
    expect(global.alert).toHaveBeenCalledTimes(1);
    expect(inputValue.value).toBe('');

    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: 999}})
    inputValue.blur();
    expect(global.alert).toHaveBeenCalledTimes(1); // 範囲内の数値を入力した場合はインクリメントされないことを確認
    expect(inputValue.value).toBe('999');

    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: -1}})
    inputValue.blur();
    expect(global.alert).toHaveBeenCalledTimes(2);
    expect(inputValue.value).toBe('');

    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: 0}})
    inputValue.blur();
    expect(global.alert).toHaveBeenCalledTimes(2); // 範囲内の数値を入力した場合はインクリメントされないことを確認
    expect(inputValue.value).toBe('0');
  });
});

describe('Radio Test', () => {    
  test('Render', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "radio_タイトル",
                shortTitle: "radio_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "radio_description",
                    displayName: "radio_displayName",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "radio_short2", 
                template_id: 1, 
                title: "radio_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "radio_description2",
                    displayName: "radio_displayName2",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "radio_タイトル",
                shortTitle: "radio_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "radio_description",
                    displayName: "radio_displayName",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "radio_short2", 
                template_id: 1, 
                title: "radio_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "radio_description2",
                    displayName: "radio_displayName2",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.radio_タイトル"})).toBeInTheDocument();
    expect(screen.getByText('※どれかひとつ選択してください。')).toBeInTheDocument();

    // field
    const radio1_1 = screen.getByRole('radio', {name: "オプション1_1"}) as HTMLInputElement;
    expect(radio1_1.value ).toBe('1,オプション1_1');
    expect(radio1_1.type).toBe('radio');

    const radio1_2 = screen.getByRole('radio', {name: "オプション1_2"}) as HTMLInputElement;
    expect(radio1_2.value ).toBe('2,オプション1_2');
    expect(radio1_2.type).toBe('radio');

    const radio1_3 = screen.getByRole('radio', {name: "オプション1_3"}) as HTMLInputElement;
    expect(radio1_3.value ).toBe('3,オプション1_3');
    expect(radio1_3.type).toBe('radio');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Back Question', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "radio_タイトル",
                shortTitle: "radio_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "radio_description",
                    displayName: "radio_displayName",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "radio_short2", 
                template_id: 1, 
                title: "radio_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "radio_description2",
                    displayName: "radio_displayName2",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "radio_タイトル",
                shortTitle: "radio_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "radio_description",
                    displayName: "radio_displayName",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "radio_short2", 
                template_id: 1, 
                title: "radio_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "radio_description2",
                    displayName: "radio_displayName2",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const radio1_2 = screen.getByRole('radio', {name: "オプション1_2"}) as HTMLInputElement;
    expect(radio1_2).not.toBeChecked();
    fireEvent.click(radio1_2);
    expect(radio1_2).toBeChecked();

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(2/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.radio_タイトル2"})).toBeInTheDocument();

    // field
    const radio2_1 = screen.getByRole('radio', {name: "オプション2_1"}) as HTMLInputElement;
    expect(radio2_1.value ).toBe('1,オプション2_1');
    expect(radio2_1.type).toBe('radio');

    const radio2_2 = screen.getByRole('radio', {name: "オプション2_2"}) as HTMLInputElement;
    expect(radio2_2.value ).toBe('2,オプション2_2');
    expect(radio2_2.type).toBe('radio');

    const radio2_3 = screen.getByRole('radio', {name: "オプション2_3"}) as HTMLInputElement;
    expect(radio2_3.value ).toBe('3,オプション2_3');
    expect(radio2_3.type).toBe('radio');

    // button
    expect(screen.queryAllByText('戻る')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const backButton2 = screen.queryAllByText('戻る')[0];
    fireEvent.click(backButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.radio_タイトル"})).toBeInTheDocument();

    // field
    const back_radio1_2 = screen.getByRole('radio', {name: "オプション1_2"}) as HTMLInputElement;
    expect(back_radio1_2).toBeChecked();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Confirmation', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "radio_タイトル",
                shortTitle: "radio_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "radio_description",
                    displayName: "radio_displayName",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "radio_short2", 
                template_id: 1, 
                title: "radio_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "radio_description2",
                    displayName: "radio_displayName2",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "radio_タイトル",
                shortTitle: "radio_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "radio_description",
                    displayName: "radio_displayName",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "radio_short2", 
                template_id: 1, 
                title: "radio_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "radio_description2",
                    displayName: "radio_displayName2",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const radio1_2 = screen.getByRole('radio', {name: "オプション1_2"}) as HTMLInputElement;
    expect(radio1_2).not.toBeChecked();
    fireEvent.click(radio1_2);
    expect(radio1_2).toBeChecked();

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    const radio2_1 = screen.getByRole('radio', {name: "オプション2_1"}) as HTMLInputElement;
    expect(radio2_1).not.toBeChecked();
    fireEvent.click(radio2_1);
    expect(radio2_1).toBeChecked();

    const nextButton2_2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2_2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'radio_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'radio_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: "オプション1_2"})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: "オプション2_1"})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();

    // 編集ボタン
    const editButton = screen.getByRole('link', {name: 'radio_short'} );
    fireEvent.click(editButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.radio_タイトル"})).toBeInTheDocument();

    // field
    const edit_radio1_2 = screen.getByRole('radio', {name: "オプション1_2"}) as HTMLInputElement;
    expect(edit_radio1_2).toBeChecked();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.getAllByText('確認画面へ')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const edit_radio1_3 = screen.getByRole('radio', {name: "オプション1_3"}) as HTMLInputElement;
    expect(edit_radio1_3).not.toBeChecked();
    fireEvent.click(edit_radio1_3);
    expect(edit_radio1_3).toBeChecked();

    // 編集ボタン
    const confirmationButton = screen.getAllByText('確認画面へ')[0];
    fireEvent.click(confirmationButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'radio_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'radio_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: "オプション1_3"})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: "オプション2_1"})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();
  });    
});

describe('textarea Test', () => {    
  test('Render', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "textarea_タイトル",
                shortTitle: "textarea_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "textarea_description",
                    displayName: "textarea_displayName",
                    fieldDefaultValue: "",
                    formName: "textarea",
                    placeholder: "textarea_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "textarea_short2", 
                template_id: 1, 
                title: "textarea_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "textarea_description2",
                    displayName: "textarea_displayName2",
                    fieldDefaultValue: "",
                    formName: "textarea",
                    placeholder: "textarea_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "textarea_タイトル",
                shortTitle: "textarea_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "textarea_description",
                    displayName: "textarea_displayName",
                    fieldDefaultValue: "",
                    formName: "textarea",
                    placeholder: "textarea_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "textarea_short2", 
                template_id: 1, 
                title: "textarea_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "textarea_description2",
                    displayName: "textarea_displayName2",
                    fieldDefaultValue: "",
                    formName: "textarea",
                    placeholder: "textarea_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.textarea_タイトル"})).toBeInTheDocument();

    // field
    const textbox2_1 = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    expect(textbox2_1.value ).toBe('');
    expect(textbox2_1.placeholder).toBe('textarea_placeholder');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Back Question', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "textarea_タイトル",
                shortTitle: "textarea_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "textarea_description",
                    displayName: "textarea_displayName",
                    fieldDefaultValue: "",
                    formName: "textarea",
                    placeholder: "textarea_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "textarea_short2", 
                template_id: 1, 
                title: "textarea_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "textarea_description2",
                    displayName: "textarea_displayName2",
                    fieldDefaultValue: "",
                    formName: "textarea",
                    placeholder: "textarea_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "textarea_タイトル",
                shortTitle: "textarea_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "textarea_description",
                    displayName: "textarea_displayName",
                    fieldDefaultValue: "",
                    formName: "textarea",
                    placeholder: "textarea_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "textarea_short2", 
                template_id: 1, 
                title: "textarea_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "textarea_description2",
                    displayName: "textarea_displayName2",
                    fieldDefaultValue: "",
                    formName: "textarea",
                    placeholder: "textarea_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const textbox2_1 = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    textbox2_1.focus();
    fireEvent.change(textbox2_1, {target: {value: 'TEST'}})
    textbox2_1.blur();
    expect(textbox2_1.value).toBe('TEST');

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(2/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.textarea_タイトル2"})).toBeInTheDocument();

    // field
    const textbox2_2 = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    expect(textbox2_2.value ).toBe('');
    expect(textbox2_2.placeholder).toBe('textarea_placeholder2');

    // button
    expect(screen.queryAllByText('戻る')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const backButton2 = screen.queryAllByText('戻る')[0];
    fireEvent.click(backButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.textarea_タイトル"})).toBeInTheDocument();

    // field
    const back_textbox2_1 = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    expect(back_textbox2_1.value ).toBe('TEST');
    expect(textbox2_1.placeholder).toBe('textarea_placeholder');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Confirmation', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "textarea_タイトル",
                shortTitle: "textarea_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "textarea_description",
                    displayName: "textarea_displayName",
                    fieldDefaultValue: "",
                    formName: "textarea",
                    placeholder: "textarea_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "textarea_short2", 
                template_id: 1, 
                title: "textarea_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "textarea_description2",
                    displayName: "textarea_displayName2",
                    fieldDefaultValue: "",
                    formName: "textarea",
                    placeholder: "textarea_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "textarea_タイトル",
                shortTitle: "textarea_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "textarea_description",
                    displayName: "textarea_displayName",
                    fieldDefaultValue: "",
                    formName: "textarea",
                    placeholder: "textarea_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "textarea_short2", 
                template_id: 1, 
                title: "textarea_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "textarea_description2",
                    displayName: "textarea_displayName2",
                    fieldDefaultValue: "",
                    formName: "textarea",
                    placeholder: "textarea_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const textbox2_1 = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    textbox2_1.focus();
    fireEvent.change(textbox2_1, {target: {value: 'TEST'}})
    textbox2_1.blur();
    expect(textbox2_1.value).toBe('TEST');

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    const textbox2_2 = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    textbox2_2.focus();
    fireEvent.change(textbox2_2, {target: {value: 'TEST2'}})
    textbox2_2.blur();
    expect(textbox2_2.value).toBe('TEST2');

    const nextButton2_2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2_2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'textarea_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'textarea_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: "TEST"})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: "TEST2"})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();

    // 編集ボタン
    const editButton = screen.getByRole('link', {name: 'textarea_short'} );
    fireEvent.click(editButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.textarea_タイトル"})).toBeInTheDocument();

    // field
    const edit_textbox = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    expect(edit_textbox.value).toBe('TEST')

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.getAllByText('確認画面へ')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const edit_textbox2_1 = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    edit_textbox2_1.focus();
    fireEvent.change(edit_textbox2_1, {target: {value: 'EDITTEST'}})
    edit_textbox2_1.blur();
    expect(edit_textbox2_1.value).toBe('EDITTEST')

    // 編集ボタン
    const confirmationButton = screen.getAllByText('確認画面へ')[0];
    fireEvent.click(confirmationButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'textarea_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'textarea_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: "EDITTEST"})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: "TEST2"})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();
  });    
});

describe('checkbox Test', () => {    
  test('Render', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "checkbox_タイトル",
                shortTitle: "checkbox_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description",
                    displayName: "checkbox_displayName",
                    fieldDefaultValue: "",
                    formName: "checkbox",
                    placeholder: "checkbox_placeholder",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "checkbox_short2", 
                template_id: 1, 
                title: "checkbox_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description2",
                    displayName: "checkbox_displayName2",
                    fieldDefaultValue: "",
                    formName: "checkbox",
                    placeholder: "checkbox_placeholder2",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "checkbox_タイトル",
                shortTitle: "checkbox_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description",
                    displayName: "checkbox_displayName",
                    fieldDefaultValue: "",
                    formName: "checkbox",
                    placeholder: "checkbox_placeholder",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "checkbox_short2", 
                template_id: 1, 
                title: "checkbox_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description2",
                    displayName: "checkbox_displayName2",
                    fieldDefaultValue: "",
                    formName: "checkbox",
                    placeholder: "checkbox_placeholder2",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.checkbox_タイトル"})).toBeInTheDocument();

    expect(screen.getByText('※複数選択できます。')).toBeInTheDocument();

    // field
    const radio1_1 = screen.getByRole('checkbox', {name: "オプション1_1"}) as HTMLInputElement;
    expect(radio1_1.value ).toBe('1,オプション1_1');
    expect(radio1_1.type).toBe('checkbox');

    const radio1_2 = screen.getByRole('checkbox', {name: "オプション1_2"}) as HTMLInputElement;
    expect(radio1_2.value ).toBe('2,オプション1_2');
    expect(radio1_2.type).toBe('checkbox');

    const radio1_3 = screen.getByRole('checkbox', {name: "オプション1_3"}) as HTMLInputElement;
    expect(radio1_3.value ).toBe('3,オプション1_3');
    expect(radio1_3.type).toBe('checkbox');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Back Question', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "checkbox_タイトル",
                shortTitle: "checkbox_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description",
                    displayName: "checkbox_displayName",
                    fieldDefaultValue: "",
                    formName: "checkbox",
                    placeholder: "checkbox_placeholder",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "checkbox_short2", 
                template_id: 1, 
                title: "checkbox_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description2",
                    displayName: "checkbox_displayName2",
                    fieldDefaultValue: "",
                    formName: "checkbox",
                    placeholder: "checkbox_placeholder2",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: true},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "checkbox_タイトル",
                shortTitle: "checkbox_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description",
                    displayName: "checkbox_displayName",
                    fieldDefaultValue: "",
                    formName: "checkbox",
                    placeholder: "checkbox_placeholder",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "checkbox_short2", 
                template_id: 1, 
                title: "checkbox_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description2",
                    displayName: "checkbox_displayName2",
                    fieldDefaultValue: "",
                    formName: "checkbox",
                    placeholder: "checkbox_placeholder2",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: true},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const checkbox1_2 = screen.getByRole('checkbox', {name: "オプション1_2"}) as HTMLInputElement;
    expect(checkbox1_2).not.toBeChecked();
    fireEvent.click(checkbox1_2);
    expect(checkbox1_2).toBeChecked();

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(2/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.checkbox_タイトル2"})).toBeInTheDocument();

    // field
    const checkbox2_1 = screen.getByRole('checkbox', {name: "オプション2_1"}) as HTMLInputElement;
    expect(checkbox2_1.value ).toBe('1,オプション2_1');
    expect(checkbox2_1.type).toBe('checkbox');

    const checkbox2_2 = screen.getByRole('checkbox', {name: "オプション2_2"}) as HTMLInputElement;
    expect(checkbox2_2.value ).toBe('2,オプション2_2');
    expect(checkbox2_2.type).toBe('checkbox');

    const checkbox2_3 = screen.getByRole('checkbox', {name: "オプション2_3"}) as HTMLInputElement;
    expect(checkbox2_3.value ).toBe('3,オプション2_3');
    expect(checkbox2_3.type).toBe('checkbox');

    // button
    expect(screen.queryAllByText('戻る')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const backButton2 = screen.queryAllByText('戻る')[0];
    fireEvent.click(backButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.checkbox_タイトル"})).toBeInTheDocument();

    // field
    const back_checkbox1_2 = screen.getByRole('checkbox', {name: "オプション1_2"}) as HTMLInputElement;
    expect(back_checkbox1_2).toBeChecked();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Confirmation', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "checkbox_タイトル",
                shortTitle: "checkbox_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description",
                    displayName: "checkbox_displayName",
                    fieldDefaultValue: "",
                    formName: "checkbox",
                    placeholder: "checkbox_placeholder",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "checkbox_short2", 
                template_id: 1, 
                title: "checkbox_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description2",
                    displayName: "checkbox_displayName2",
                    fieldDefaultValue: "",
                    formName: "checkbox",
                    placeholder: "checkbox_placeholder2",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: true},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "checkbox_タイトル",
                shortTitle: "checkbox_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description",
                    displayName: "checkbox_displayName",
                    fieldDefaultValue: "",
                    formName: "checkbox",
                    placeholder: "checkbox_placeholder",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "checkbox_short2", 
                template_id: 1, 
                title: "checkbox_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description2",
                    displayName: "checkbox_displayName2",
                    fieldDefaultValue: "",
                    formName: "checkbox",
                    placeholder: "checkbox_placeholder2",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: true},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const checkbox1_2 = screen.getByRole('checkbox', {name: "オプション1_2"}) as HTMLInputElement;
    expect(checkbox1_2).not.toBeChecked();
    fireEvent.click(checkbox1_2);
    expect(checkbox1_2).toBeChecked();

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    const checkbox2_1 = screen.getByRole('checkbox', {name: "オプション2_1"}) as HTMLInputElement;
    expect(checkbox2_1).not.toBeChecked();
    fireEvent.click(checkbox2_1);
    expect(checkbox2_1).toBeChecked();

    const nextButton2_2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2_2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'checkbox_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'checkbox_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: "オプション1_2"})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: "オプション2_1"})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();

    // 編集ボタン
    const editButton = screen.getByRole('link', {name: 'checkbox_short'} );
    fireEvent.click(editButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.checkbox_タイトル"})).toBeInTheDocument();

    // field
    const edit_checkbox1_2 = screen.getByRole('checkbox', {name: "オプション1_2"}) as HTMLInputElement;
    expect(edit_checkbox1_2).toBeChecked();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.getAllByText('確認画面へ')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const edit_checkbox1_3 = screen.getByRole('checkbox', {name: "オプション1_3"}) as HTMLInputElement;
    expect(edit_checkbox1_3).not.toBeChecked();
    fireEvent.click(edit_checkbox1_3);
    expect(edit_checkbox1_3).toBeChecked();

    // 編集ボタン
    const confirmationButton = screen.getAllByText('確認画面へ')[0];
    fireEvent.click(confirmationButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'checkbox_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'checkbox_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: "オプション1_2,オプション1_3"})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: "オプション2_1"})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();
  });       
});

describe('img_checkbox Test', () => {    
  test('Render', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "checkbox_タイトル",
                shortTitle: "checkbox_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description",
                    displayName: "checkbox_displayName",
                    fieldDefaultValue: "",
                    formName: "checkbox_img",
                    placeholder: "checkbox_placeholder",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "checkbox_short2", 
                template_id: 1, 
                title: "checkbox_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description2",
                    displayName: "checkbox_displayName2",
                    fieldDefaultValue: "",
                    formName: "checkbox_img",
                    placeholder: "checkbox_placeholder2",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "checkbox_タイトル",
                shortTitle: "checkbox_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description",
                    displayName: "checkbox_displayName",
                    fieldDefaultValue: "",
                    formName: "checkbox_img",
                    placeholder: "checkbox_placeholder",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "checkbox_short2", 
                template_id: 1, 
                title: "checkbox_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description2",
                    displayName: "checkbox_displayName2",
                    fieldDefaultValue: "",
                    formName: "checkbox_img",
                    placeholder: "checkbox_placeholder2",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.checkbox_タイトル"})).toBeInTheDocument();

    expect(screen.getByText('※複数選択できます。')).toBeInTheDocument();

    // field
    const radio1_1 = screen.getByRole('checkbox', {name: "オプション1_1"}) as HTMLInputElement;
    expect(radio1_1.value ).toBe('1,オプション1_1');
    expect(radio1_1.type).toBe('checkbox');

    const radio1_2 = screen.getByRole('checkbox', {name: "オプション1_2"}) as HTMLInputElement;
    expect(radio1_2.value ).toBe('2,オプション1_2');
    expect(radio1_2.type).toBe('checkbox');

    const radio1_3 = screen.getByRole('checkbox', {name: "オプション1_3"}) as HTMLInputElement;
    expect(radio1_3.value ).toBe('3,オプション1_3');
    expect(radio1_3.type).toBe('checkbox');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Back Question', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "checkbox_タイトル",
                shortTitle: "checkbox_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description",
                    displayName: "checkbox_displayName",
                    fieldDefaultValue: "",
                    formName: "checkbox",
                    placeholder: "checkbox_placeholder",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "checkbox_short2", 
                template_id: 1, 
                title: "checkbox_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description2",
                    displayName: "checkbox_displayName2",
                    fieldDefaultValue: "",
                    formName: "checkbox",
                    placeholder: "checkbox_placeholder2",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: true},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "checkbox_タイトル",
                shortTitle: "checkbox_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description",
                    displayName: "checkbox_displayName",
                    fieldDefaultValue: "",
                    formName: "checkbox",
                    placeholder: "checkbox_placeholder",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "checkbox_short2", 
                template_id: 1, 
                title: "checkbox_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description2",
                    displayName: "checkbox_displayName2",
                    fieldDefaultValue: "",
                    formName: "checkbox",
                    placeholder: "checkbox_placeholder2",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: true},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const checkbox1_2 = screen.getByRole('checkbox', {name: "オプション1_2"}) as HTMLInputElement;
    expect(checkbox1_2).not.toBeChecked();
    fireEvent.click(checkbox1_2);
    expect(checkbox1_2).toBeChecked();

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(2/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.checkbox_タイトル2"})).toBeInTheDocument();

    // field
    const checkbox2_1 = screen.getByRole('checkbox', {name: "オプション2_1"}) as HTMLInputElement;
    expect(checkbox2_1.value ).toBe('1,オプション2_1');
    expect(checkbox2_1.type).toBe('checkbox');

    const checkbox2_2 = screen.getByRole('checkbox', {name: "オプション2_2"}) as HTMLInputElement;
    expect(checkbox2_2.value ).toBe('2,オプション2_2');
    expect(checkbox2_2.type).toBe('checkbox');

    const checkbox2_3 = screen.getByRole('checkbox', {name: "オプション2_3"}) as HTMLInputElement;
    expect(checkbox2_3.value ).toBe('3,オプション2_3');
    expect(checkbox2_3.type).toBe('checkbox');

    // button
    expect(screen.queryAllByText('戻る')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const backButton2 = screen.queryAllByText('戻る')[0];
    fireEvent.click(backButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.checkbox_タイトル"})).toBeInTheDocument();

    // field
    const back_checkbox1_2 = screen.getByRole('checkbox', {name: "オプション1_2"}) as HTMLInputElement;
    expect(back_checkbox1_2).toBeChecked();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Confirmation', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "checkbox_タイトル",
                shortTitle: "checkbox_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description",
                    displayName: "checkbox_displayName",
                    fieldDefaultValue: "",
                    formName: "checkbox",
                    placeholder: "checkbox_placeholder",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "checkbox_short2", 
                template_id: 1, 
                title: "checkbox_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description2",
                    displayName: "checkbox_displayName2",
                    fieldDefaultValue: "",
                    formName: "checkbox",
                    placeholder: "checkbox_placeholder2",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: true},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "checkbox_タイトル",
                shortTitle: "checkbox_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description",
                    displayName: "checkbox_displayName",
                    fieldDefaultValue: "",
                    formName: "checkbox",
                    placeholder: "checkbox_placeholder",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "checkbox_short2", 
                template_id: 1, 
                title: "checkbox_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "checkbox_description2",
                    displayName: "checkbox_displayName2",
                    fieldDefaultValue: "",
                    formName: "checkbox",
                    placeholder: "checkbox_placeholder2",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: true},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const checkbox1_2 = screen.getByRole('checkbox', {name: "オプション1_2"}) as HTMLInputElement;
    expect(checkbox1_2).not.toBeChecked();
    fireEvent.click(checkbox1_2);
    expect(checkbox1_2).toBeChecked();

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    const checkbox2_1 = screen.getByRole('checkbox', {name: "オプション2_1"}) as HTMLInputElement;
    expect(checkbox2_1).not.toBeChecked();
    fireEvent.click(checkbox2_1);
    expect(checkbox2_1).toBeChecked();

    const nextButton2_2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2_2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'checkbox_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'checkbox_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: "オプション1_2"})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: "オプション2_1"})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();

    // 編集ボタン
    const editButton = screen.getByRole('link', {name: 'checkbox_short'} );
    fireEvent.click(editButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.checkbox_タイトル"})).toBeInTheDocument();

    // field
    const edit_checkbox1_2 = screen.getByRole('checkbox', {name: "オプション1_2"}) as HTMLInputElement;
    expect(edit_checkbox1_2).toBeChecked();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.getAllByText('確認画面へ')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const edit_checkbox1_3 = screen.getByRole('checkbox', {name: "オプション1_3"}) as HTMLInputElement;
    expect(edit_checkbox1_3).not.toBeChecked();
    fireEvent.click(edit_checkbox1_3);
    expect(edit_checkbox1_3).toBeChecked();

    // 編集ボタン
    const confirmationButton = screen.getAllByText('確認画面へ')[0];
    fireEvent.click(confirmationButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'checkbox_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'checkbox_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: "オプション1_2,オプション1_3"})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: "オプション2_1"})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();
  });       
});

describe('SelectList Test', () => {    
  test('Render', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "select_list_タイトル",
                shortTitle: "select_list_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "select_list_description",
                    displayName: "select_list_displayName",
                    fieldDefaultValue: "",
                    formName: "select_list",
                    placeholder: "select_list_placeholder",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "select_list_short2", 
                template_id: 1, 
                title: "select_list_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "select_list_description2",
                    displayName: "select_list_displayName2",
                    fieldDefaultValue: "",
                    formName: "select_list",
                    placeholder: "select_list_placeholder2",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "select_list_タイトル",
                shortTitle: "select_list_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "select_list_description",
                    displayName: "select_list_displayName",
                    fieldDefaultValue: "",
                    formName: "select_list",
                    placeholder: "select_list_placeholder",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "select_list_short2", 
                template_id: 1, 
                title: "select_list_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "select_list_description2",
                    displayName: "select_list_displayName2",
                    fieldDefaultValue: "",
                    formName: "select_list",
                    placeholder: "select_list_placeholder2",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.select_list_タイトル"})).toBeInTheDocument();

    // field
    const radio1_1 = screen.getByRole('option', {name: "オプション1_1"}) as HTMLInputElement;
    expect(radio1_1.value ).toBe('1,オプション1_1,true');

    const radio1_2 = screen.getByRole('option', {name: "オプション1_2"}) as HTMLInputElement;
    expect(radio1_2.value ).toBe('2,オプション1_2,false');

    const radio1_3 = screen.getByRole('option', {name: "オプション1_3"}) as HTMLInputElement;
    expect(radio1_3.value ).toBe('3,オプション1_3,false');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Back Question', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "select_list_タイトル",
                shortTitle: "select_list_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "select_list_description",
                    displayName: "select_list_displayName",
                    fieldDefaultValue: "",
                    formName: "select_list",
                    placeholder: "select_list_placeholder",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "select_list_short2", 
                template_id: 1, 
                title: "select_list_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "select_list_description2",
                    displayName: "select_list_displayName2",
                    fieldDefaultValue: "",
                    formName: "select_list",
                    placeholder: "select_list_placeholder2",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: true},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "select_list_タイトル",
                shortTitle: "select_list_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "select_list_description",
                    displayName: "select_list_displayName",
                    fieldDefaultValue: "",
                    formName: "select_list",
                    placeholder: "select_list_placeholder",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "select_list_short2", 
                template_id: 1, 
                title: "select_list_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "select_list_description2",
                    displayName: "select_list_displayName2",
                    fieldDefaultValue: "",
                    formName: "select_list",
                    placeholder: "select_list_placeholder2",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: true},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const select_list1_1 = screen.getByRole('option', {name: "オプション1_1"}) as HTMLOptionElement;
    const select_list1_2 = screen.getByRole('option', {name: "オプション1_2"}) as HTMLOptionElement;
    const select_list1_3 = screen.getByRole('option', {name: "オプション1_3"}) as HTMLOptionElement;
    const select = screen.getByRole('combobox', {name: "select_list_displayName"}) as HTMLInputElement;

    fireEvent.change(select, { target: { value: "2,オプション1_2,false" } })
    expect(select_list1_1.selected).toBeFalsy();
    expect(select_list1_2.selected).toBeTruthy();
    expect(select_list1_3.selected).toBeFalsy();

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(2/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.select_list_タイトル2"})).toBeInTheDocument();

    // field
    const select_list2_1 = screen.getByRole('option', {name: "オプション2_1"}) as HTMLInputElement;
    expect(select_list2_1.value ).toBe('1,オプション2_1,true');

    const select_list2_2 = screen.getByRole('option', {name: "オプション2_2"}) as HTMLInputElement;
    expect(select_list2_2.value ).toBe('2,オプション2_2,false');

    const select_list2_3 = screen.getByRole('option', {name: "オプション2_3"}) as HTMLInputElement;
    expect(select_list2_3.value ).toBe('3,オプション2_3,false');

    // button
    expect(screen.queryAllByText('戻る')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const backButton2 = screen.queryAllByText('戻る')[0];
    fireEvent.click(backButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.select_list_タイトル"})).toBeInTheDocument();

    // field
    const back_select_list1_1 = screen.getByRole('option', {name: "オプション1_1"}) as HTMLOptionElement;
    const back_select_list1_2 = screen.getByRole('option', {name: "オプション1_2"}) as HTMLOptionElement;
    const back_select_list1_3 = screen.getByRole('option', {name: "オプション1_3"}) as HTMLOptionElement;

    expect(back_select_list1_1.selected).toBeFalsy();
    expect(back_select_list1_2.selected).toBeTruthy();
    expect(back_select_list1_3.selected).toBeFalsy();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Confirmation', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "select_list_タイトル",
                shortTitle: "select_list_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "select_list_description",
                    displayName: "select_list_displayName",
                    fieldDefaultValue: "",
                    formName: "select_list",
                    placeholder: "select_list_placeholder",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "select_list_short2", 
                template_id: 1, 
                title: "select_list_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "select_list_description2",
                    displayName: "select_list_displayName2",
                    fieldDefaultValue: "",
                    formName: "select_list",
                    placeholder: "select_list_placeholder2",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: true},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "select_list_タイトル",
                shortTitle: "select_list_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "select_list_description",
                    displayName: "select_list_displayName",
                    fieldDefaultValue: "",
                    formName: "select_list",
                    placeholder: "select_list_placeholder",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: true},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "select_list_short2", 
                template_id: 1, 
                title: "select_list_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "select_list_description2",
                    displayName: "select_list_displayName2",
                    fieldDefaultValue: "",
                    formName: "select_list",
                    placeholder: "select_list_placeholder2",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: true},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const select_list1_1 = screen.getByRole('option', {name: "オプション1_1"}) as HTMLOptionElement;
    const select_list1_2 = screen.getByRole('option', {name: "オプション1_2"}) as HTMLOptionElement;
    const select_list1_3 = screen.getByRole('option', {name: "オプション1_3"}) as HTMLOptionElement;
    const select = screen.getByRole('combobox', {name: "select_list_displayName"}) as HTMLInputElement;

    fireEvent.change(select, { target: { value: "2,オプション1_2,false" } })
    expect(select_list1_1.selected).toBeFalsy();
    expect(select_list1_2.selected).toBeTruthy();
    expect(select_list1_3.selected).toBeFalsy();

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    const select_list2_1 = screen.getByRole('option', {name: "オプション2_1"}) as HTMLOptionElement;
    const select_list2_2 = screen.getByRole('option', {name: "オプション2_2"}) as HTMLOptionElement;
    const select_list2_3 = screen.getByRole('option', {name: "オプション2_3"}) as HTMLOptionElement;
    const select2 = screen.getByRole('combobox', {name: "select_list_displayName2"}) as HTMLInputElement;

    fireEvent.change(select2, { target: { value: "3,オプション2_3,false" } })
    expect(select_list2_1.selected).toBeFalsy();
    expect(select_list2_2.selected).toBeFalsy();
    expect(select_list2_3.selected).toBeTruthy();

    const nextButton2_2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2_2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'select_list_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'select_list_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: "オプション1_2"})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: "オプション2_3"})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();

    // 編集ボタン
    const editButton = screen.getByRole('link', {name: 'select_list_short'} );
    fireEvent.click(editButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.select_list_タイトル"})).toBeInTheDocument();

    // field
    const edit_select_list1_1 = screen.getByRole('option', {name: "オプション1_1"}) as HTMLOptionElement;
    const edit_select_list1_2 = screen.getByRole('option', {name: "オプション1_2"}) as HTMLOptionElement;
    const edit_select_list1_3 = screen.getByRole('option', {name: "オプション1_3"}) as HTMLOptionElement;
    expect(edit_select_list1_1.selected).toBeFalsy();
    expect(edit_select_list1_2.selected).toBeTruthy();
    expect(edit_select_list1_3.selected).toBeFalsy();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.getAllByText('確認画面へ')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const edit_select = screen.getByRole('combobox', {name: "select_list_displayName"}) as HTMLInputElement;
    fireEvent.change(edit_select, {target: { value: "1,オプション1_1,true"}});

    const edit_select2_list1_1 = screen.getByRole('option', {name: "オプション1_1"}) as HTMLOptionElement;
    const edit_select2_list1_2 = screen.getByRole('option', {name: "オプション1_2"}) as HTMLOptionElement;
    const edit_select2_list1_3 = screen.getByRole('option', {name: "オプション1_3"}) as HTMLOptionElement;

    expect(edit_select2_list1_1.selected).toBeTruthy();
    expect(edit_select2_list1_2.selected).toBeFalsy();
    expect(edit_select2_list1_3.selected).toBeFalsy();

    // 編集ボタン
    const confirmationButton = screen.getAllByText('確認画面へ')[1];
    fireEvent.click(confirmationButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'select_list_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'select_list_short2'})).toBeInTheDocument();

    expect(screen.queryByText('オプション1_1')).toBeNull();
    expect(screen.getByRole('cell', {name: "オプション2_3"})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();
  });       
});


describe('Input(date) Test', () => {   
  test('Render', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(date)_タイトル",
                shortTitle: "input(date)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(date)_description",
                    displayLeft: "input(date)_displayLeft",
                    displayName: "input(date)_displayName",
                    displayRight: "input(date)_displayRight",
                    fieldDefaultValue: "2022-01-03",
                    formName: "date",
                    placeholder: "input(date)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(date)_short2", 
                template_id: 1, 
                title: "input(date)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(date)_description2",
                    displayLeft: "input(date)_displayLeft2",
                    displayName: "input(date)_displayName2",
                    displayRight: "input(date)_displayRight2",
                    fieldDefaultValue: "2022-01-04",
                    formName: "date",
                    placeholder: "input(date)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(date)_タイトル",
                shortTitle: "input(date)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(date)_description",
                    displayLeft: "input(date)_displayLeft",
                    displayName: "input(date)_displayName",
                    displayRight: "input(date)_displayRight",
                    fieldDefaultValue: "2022-01-03",
                    formName: "date",
                    placeholder: "input(date)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(date)_short2", 
                template_id: 1, 
                title: "input(date)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(date)_description2",
                    displayLeft: "input(date)_displayLeft2",
                    displayName: "input(date)_displayName2",
                    displayRight: "input(date)_displayRight2",
                    fieldDefaultValue: "2022-01-04",
                    formName: "date",
                    placeholder: "input(date)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.input(date)_タイトル"})).toBeInTheDocument();
    expect(screen.getByText('input(date)_displayName')).toBeInTheDocument();
    expect(screen.getAllByText('input(date)_displayLeft')[0]).toBeInTheDocument();
    expect(screen.getAllByText('input(date)_displayRight')[0]).toBeInTheDocument();

    // field
    const textbox2 = screen.getByPlaceholderText('input(date)_placeholder') as HTMLInputElement;
    expect(textbox2.value ).toBe('2022-01-03');
    expect(textbox2.placeholder).toBe('input(date)_placeholder');
    expect(textbox2.type).toBe('tel');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Back Question', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(date)_タイトル",
                shortTitle: "input(date)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(date)_description",
                    displayLeft: "input(date)_displayLeft",
                    displayName: "input(date)_displayName",
                    displayRight: "input(date)_displayRight",
                    fieldDefaultValue: "2022-01-03",
                    formName: "date",
                    placeholder: "input(date)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(date)_short2", 
                template_id: 1, 
                title: "input(date)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(date)_description2",
                    displayLeft: "input(date)_displayLeft2",
                    displayName: "input(date)_displayName2",
                    displayRight: "input(date)_displayRight2",
                    fieldDefaultValue: "2022-01-04",
                    formName: "date",
                    placeholder: "input(date)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(date)_タイトル",
                shortTitle: "input(date)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(date)_description",
                    displayLeft: "input(date)_displayLeft",
                    displayName: "input(date)_displayName",
                    displayRight: "input(date)_displayRight",
                    fieldDefaultValue: "2022-01-03",
                    formName: "date",
                    placeholder: "input(date)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(date)_short2", 
                template_id: 1, 
                title: "input(date)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(date)_description2",
                    displayLeft: "input(date)_displayLeft2",
                    displayName: "input(date)_displayName2",
                    displayRight: "input(date)_displayRight2",
                    fieldDefaultValue: "2022-01-04",
                    formName: "date",
                    placeholder: "input(date)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const inputValue = screen.getByPlaceholderText('input(date)_placeholder') as HTMLInputElement;
    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: '2022-03-01'}})
    inputValue.blur();
    expect(inputValue.value).toBe('2022-03-01');

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(2/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.input(date)_タイトル2"})).toBeInTheDocument();
    expect(screen.getByText('input(date)_displayName2')).toBeInTheDocument();

    // main
    expect(screen.getAllByText('input(date)_displayLeft2')[0]).toBeInTheDocument();
    expect(screen.getAllByText('input(date)_displayRight2')[0]).toBeInTheDocument();

    // field
    const textbox2_2 = screen.getByPlaceholderText('input(date)_placeholder2') as HTMLInputElement;
    expect(textbox2_2.value).toBe('2022-01-04');
    expect(textbox2_2.placeholder).toBe('input(date)_placeholder2');
    expect(textbox2_2.type).toBe('tel');

    // button
    expect(screen.queryAllByText('戻る')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const backButton2 = screen.queryAllByText('戻る')[0];
    fireEvent.click(backButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.input(date)_タイトル"})).toBeInTheDocument();
    expect(screen.getByText('input(date)_displayName')).toBeInTheDocument();

    // main
    expect(screen.getAllByText('input(date)_displayLeft')[0]).toBeInTheDocument();
    expect(screen.getAllByText('input(date)_displayRight')[0]).toBeInTheDocument();

    // field
    const textbox2 = screen.getByPlaceholderText('input(date)_placeholder') as HTMLInputElement;
    expect(textbox2.value).toBe('2022-03-01');
    expect(textbox2.placeholder).toBe('input(date)_placeholder');
    expect(textbox2.type).toBe('tel');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Confirmation', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(date)_タイトル",
                shortTitle: "input(date)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(date)_description",
                    displayLeft: "input(date)_displayLeft",
                    displayName: "input(date)_displayName",
                    displayRight: "input(date)_displayRight",
                    fieldDefaultValue: "2022-01-03",
                    formName: "date",
                    placeholder: "input(date)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(date)_short2", 
                template_id: 1, 
                title: "input(date)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(date)_description2",
                    displayLeft: "input(date)_displayLeft2",
                    displayName: "input(date)_displayName2",
                    displayRight: "input(date)_displayRight2",
                    fieldDefaultValue: "2022-01-04",
                    formName: "date",
                    placeholder: "input(date)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(date)_タイトル",
                shortTitle: "input(date)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(date)_description",
                    displayLeft: "input(date)_displayLeft",
                    displayName: "input(date)_displayName",
                    displayRight: "input(date)_displayRight",
                    fieldDefaultValue: "2022-01-03",
                    formName: "date",
                    placeholder: "input(date)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(date)_short2", 
                template_id: 1, 
                title: "input(date)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(date)_description2",
                    displayLeft: "input(date)_displayLeft2",
                    displayName: "input(date)_displayName2",
                    displayRight: "input(date)_displayRight2",
                    fieldDefaultValue: "2022-01-04",
                    formName: "date",
                    placeholder: "input(date)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const inputValue = screen.getByPlaceholderText('input(date)_placeholder') as HTMLInputElement;
    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: '2022-03-01'}})
    inputValue.blur();
    expect(inputValue.value).toBe('2022-03-01');

    const nextButton1 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton1);

    const inputValue2 = screen.getByPlaceholderText('input(date)_placeholder2') as HTMLInputElement;
    inputValue2.focus();
    fireEvent.change(inputValue2, {target: {value: '2022-03-10'}})
    inputValue2.blur();
    expect(inputValue2.value).toBe('2022-03-10');

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'input(date)_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'input(date)_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: '2022-03-01'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '2022-03-10'})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();

    // 編集ボタン
    const editButton = screen.getByRole('link', {name: 'input(date)_short'} );
    fireEvent.click(editButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.input(date)_タイトル"})).toBeInTheDocument();
    expect(screen.getByText('input(date)_displayName')).toBeInTheDocument();
    expect(screen.getAllByText('input(date)_displayLeft')[0]).toBeInTheDocument();
    expect(screen.getAllByText('input(date)_displayRight')[0]).toBeInTheDocument();

    // field
    const textbox2 = screen.getByPlaceholderText('input(date)_placeholder') as HTMLInputElement;
    expect(textbox2.value ).toBe('2022-03-01');
    expect(textbox2.placeholder).toBe('input(date)_placeholder');
    expect(textbox2.type).toBe('tel');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.getAllByText('確認画面へ')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const editInputValue = screen.getByPlaceholderText('input(date)_placeholder') as HTMLInputElement;
    editInputValue.focus();
    fireEvent.change(editInputValue, {target: {value: '2022-04-10'}})
    editInputValue.blur();
    expect(editInputValue.value).toBe('2022-04-10');

    // 編集ボタン
    const confirmationButton = screen.getAllByText('確認画面へ')[0];
    fireEvent.click(confirmationButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'input(date)_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'input(date)_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: '2022-04-10'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '2022-03-10'})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();
  });    
});


describe('special address Test', () => {   
  test('Render', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 4, 
                title: "special(address)_タイトル",
                shortTitle: "special(address)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description1",
                    displayLeft: "special(address)_displayLeft1",
                    displayName: "special(address)_displayName1",
                    displayRight: "special(address)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder1",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2",
                    displayLeft: "special(address)_displayLeft2",
                    displayName: "special(address)_displayName2",
                    displayRight: "special(address)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description3",
                    displayLeft: "special(address)_displayLeft3",
                    displayName: "special(address)_displayName3",
                    displayRight: "special(address)_displayRight3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder3",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 4, 
                questionNumber: 1, 
                shortTitle: "special(address)_short2", 
                template_id: 1, 
                title: "special(address)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-1",
                    displayLeft: "special(address)_displayLeft2-1",
                    displayName: "special(address)_displayName2-1",
                    displayRight: "special(address)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-1",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-2",
                    displayLeft: "special(address)_displayLeft2-2",
                    displayName: "special(address)_displayName2-2",
                    displayRight: "special(address)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-3",
                    displayLeft: "special(address)_displayLeft2-3",
                    displayName: "special(address)_displayName2-3",
                    displayRight: "special(address)_displayRight2-3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-3",
                    options: []
                  }
                ]
              }
            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 4, 
                title: "special(address)_タイトル",
                shortTitle: "special(address)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description1",
                    displayLeft: "special(address)_displayLeft1",
                    displayName: "special(address)_displayName1",
                    displayRight: "special(address)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder1",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2",
                    displayLeft: "special(address)_displayLeft2",
                    displayName: "special(address)_displayName2",
                    displayRight: "special(address)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description3",
                    displayLeft: "special(address)_displayLeft3",
                    displayName: "special(address)_displayName3",
                    displayRight: "special(address)_displayRight3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder3",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 4, 
                questionNumber: 1, 
                shortTitle: "special(address)_short2", 
                template_id: 1, 
                title: "special(address)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-1",
                    displayLeft: "special(address)_displayLeft2-1",
                    displayName: "special(address)_displayName2-1",
                    displayRight: "special(address)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-1",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-2",
                    displayLeft: "special(address)_displayLeft2-2",
                    displayName: "special(address)_displayName2-2",
                    displayRight: "special(address)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-3",
                    displayLeft: "special(address)_displayLeft2-3",
                    displayName: "special(address)_displayName2-3",
                    displayRight: "special(address)_displayRight2-3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-3",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.special(address)_タイトル"})).toBeInTheDocument();
    expect(screen.getAllByText('special(address)_displayLeft1')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(address)_displayLeft2')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(address)_displayLeft3')[0]).toBeInTheDocument();

    // field
    const textbox2_1 = screen.getAllByRole('textbox', {name: ""})[0] as HTMLInputElement;
    const textbox2_2 = screen.getAllByRole('textbox', {name: ""})[1] as HTMLInputElement;
    const textbox2_3 = screen.getAllByRole('textbox', {name: ""})[2] as HTMLInputElement;

    expect(textbox2_1.value ).toBe('');
    expect(textbox2_1.placeholder).toBe('special(address)_placeholder1');
    expect(textbox2_1.type).toBe('tel');

    expect(textbox2_2.value ).toBe('');
    expect(textbox2_2.placeholder).toBe('special(address)_placeholder2');
    expect(textbox2_2.type).toBe('text');

    expect(textbox2_3.value ).toBe('');
    expect(textbox2_3.placeholder).toBe('special(address)_placeholder3');
    expect(textbox2_3.type).toBe('text');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Back Question', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 4, 
                title: "special(address)_タイトル",
                shortTitle: "special(address)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description1",
                    displayLeft: "special(address)_displayLeft1",
                    displayName: "special(address)_displayName1",
                    displayRight: "special(address)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder1",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2",
                    displayLeft: "special(address)_displayLeft2",
                    displayName: "special(address)_displayName2",
                    displayRight: "special(address)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description3",
                    displayLeft: "special(address)_displayLeft3",
                    displayName: "special(address)_displayName3",
                    displayRight: "special(address)_displayRight3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder3",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 4, 
                questionNumber: 1, 
                shortTitle: "special(address)_short2", 
                template_id: 1, 
                title: "special(address)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-1",
                    displayLeft: "special(address)_displayLeft2-1",
                    displayName: "special(address)_displayName2-1",
                    displayRight: "special(address)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-1",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-2",
                    displayLeft: "special(address)_displayLeft2-2",
                    displayName: "special(address)_displayName2-2",
                    displayRight: "special(address)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-3",
                    displayLeft: "special(address)_displayLeft2-3",
                    displayName: "special(address)_displayName2-3",
                    displayRight: "special(address)_displayRight2-3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-3",
                    options: []
                  }
                ]
              }
            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 4, 
                title: "special(address)_タイトル",
                shortTitle: "special(address)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description1",
                    displayLeft: "special(address)_displayLeft1",
                    displayName: "special(address)_displayName1",
                    displayRight: "special(address)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder1",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2",
                    displayLeft: "special(address)_displayLeft2",
                    displayName: "special(address)_displayName2",
                    displayRight: "special(address)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description3",
                    displayLeft: "special(address)_displayLeft3",
                    displayName: "special(address)_displayName3",
                    displayRight: "special(address)_displayRight3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder3",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 4, 
                questionNumber: 1, 
                shortTitle: "special(address)_short2", 
                template_id: 1, 
                title: "special(address)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-1",
                    displayLeft: "special(address)_displayLeft2-1",
                    displayName: "special(address)_displayName2-1",
                    displayRight: "special(address)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-1",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-2",
                    displayLeft: "special(address)_displayLeft2-2",
                    displayName: "special(address)_displayName2-2",
                    displayRight: "special(address)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-3",
                    displayLeft: "special(address)_displayLeft2-3",
                    displayName: "special(address)_displayName2-3",
                    displayRight: "special(address)_displayRight2-3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-3",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const inputValue2_1 = screen.getAllByRole('textbox', {name: ""})[0] as HTMLInputElement;
    const inputValue2_2 = screen.getAllByRole('textbox', {name: ""})[1] as HTMLInputElement;
    const inputValue2_3 = screen.getAllByRole('textbox', {name: ""})[2] as HTMLInputElement;

    inputValue2_1.focus();
    fireEvent.change(inputValue2_1, {target: {value: '1000000'}})
    inputValue2_1.blur();
    expect(inputValue2_1.value).toBe('1000000');

    inputValue2_2.focus();
    fireEvent.change(inputValue2_2, {target: {value: '住所欄１'}})
    inputValue2_2.blur();
    expect(inputValue2_2.value).toBe('住所欄１');

    inputValue2_3.focus();
    fireEvent.change(inputValue2_3, {target: {value: '住所欄２'}})
    inputValue2_3.blur();
    expect(inputValue2_3.value).toBe('住所欄２');

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(2/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.special(address)_タイトル2"})).toBeInTheDocument();

    // main
    expect(screen.getAllByText('special(address)_displayLeft2-1')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(address)_displayLeft2-2')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(address)_displayLeft2-2')[0]).toBeInTheDocument();

    // field
    const textbox2_2_1 = screen.getAllByRole('textbox', {name: ""})[0] as HTMLInputElement;
    const textbox2_2_2 = screen.getAllByRole('textbox', {name: ""})[1] as HTMLInputElement;
    const textbox2_2_3 = screen.getAllByRole('textbox', {name: ""})[2] as HTMLInputElement;

    expect(textbox2_2_1.value).toBe('');
    expect(textbox2_2_1.placeholder).toBe('special(address)_placeholder2-1');
    expect(textbox2_2_1.type).toBe('tel');

    expect(textbox2_2_2.value).toBe('');
    expect(textbox2_2_2.placeholder).toBe('special(address)_placeholder2-2');
    expect(textbox2_2_2.type).toBe('text');

    expect(textbox2_2_3.value).toBe('');
    expect(textbox2_2_3.placeholder).toBe('special(address)_placeholder2-3');
    expect(textbox2_2_3.type).toBe('text');

    // button
    expect(screen.queryAllByText('戻る')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const backButton2 = screen.queryAllByText('戻る')[0];
    fireEvent.click(backButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.special(address)_タイトル"})).toBeInTheDocument();

    // main
    expect(screen.getAllByText('special(address)_displayLeft1')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(address)_displayLeft2')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(address)_displayLeft3')[0]).toBeInTheDocument();

    // field
    const textbox2_1_1 = screen.getAllByRole('textbox', {name: ""})[0] as HTMLInputElement;
    const textbox2_1_2 = screen.getAllByRole('textbox', {name: ""})[1] as HTMLInputElement;
    const textbox2_1_3 = screen.getAllByRole('textbox', {name: ""})[2] as HTMLInputElement;
    
    expect(textbox2_1_1.value).toBe('1000000');
    expect(textbox2_1_1.placeholder).toBe('special(address)_placeholder1');
    expect(textbox2_1_1.type).toBe('tel');

    expect(textbox2_1_2.value).toBe('住所欄１');
    expect(textbox2_1_2.placeholder).toBe('special(address)_placeholder2');
    expect(textbox2_1_2.type).toBe('text');

    expect(textbox2_1_3.value).toBe('住所欄２');
    expect(textbox2_1_3.placeholder).toBe('special(address)_placeholder3');
    expect(textbox2_1_3.type).toBe('text');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Confirmation', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 4, 
                title: "special(address)_タイトル",
                shortTitle: "special(address)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description1",
                    displayLeft: "special(address)_displayLeft1",
                    displayName: "special(address)_displayName1",
                    displayRight: "special(address)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder1",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2",
                    displayLeft: "special(address)_displayLeft2",
                    displayName: "special(address)_displayName2",
                    displayRight: "special(address)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description3",
                    displayLeft: "special(address)_displayLeft3",
                    displayName: "special(address)_displayName3",
                    displayRight: "special(address)_displayRight3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder3",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 4, 
                questionNumber: 1, 
                shortTitle: "special(address)_short2", 
                template_id: 1, 
                title: "special(address)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-1",
                    displayLeft: "special(address)_displayLeft2-1",
                    displayName: "special(address)_displayName2-1",
                    displayRight: "special(address)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-1",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-2",
                    displayLeft: "special(address)_displayLeft2-2",
                    displayName: "special(address)_displayName2-2",
                    displayRight: "special(address)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-3",
                    displayLeft: "special(address)_displayLeft2-3",
                    displayName: "special(address)_displayName2-3",
                    displayRight: "special(address)_displayRight2-3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-3",
                    options: []
                  }
                ]
              }
            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 4, 
                title: "special(address)_タイトル",
                shortTitle: "special(address)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description1",
                    displayLeft: "special(address)_displayLeft1",
                    displayName: "special(address)_displayName1",
                    displayRight: "special(address)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder1",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2",
                    displayLeft: "special(address)_displayLeft2",
                    displayName: "special(address)_displayName2",
                    displayRight: "special(address)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description3",
                    displayLeft: "special(address)_displayLeft3",
                    displayName: "special(address)_displayName3",
                    displayRight: "special(address)_displayRight3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder3",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 4, 
                questionNumber: 1, 
                shortTitle: "special(address)_short2", 
                template_id: 1, 
                title: "special(address)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-1",
                    displayLeft: "special(address)_displayLeft2-1",
                    displayName: "special(address)_displayName2-1",
                    displayRight: "special(address)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-1",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-2",
                    displayLeft: "special(address)_displayLeft2-2",
                    displayName: "special(address)_displayName2-2",
                    displayRight: "special(address)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-3",
                    displayLeft: "special(address)_displayLeft2-3",
                    displayName: "special(address)_displayName2-3",
                    displayRight: "special(address)_displayRight2-3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-3",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const inputValue2_1 = screen.getAllByRole('textbox', {name: ""})[0] as HTMLInputElement;
    const inputValue2_2 = screen.getAllByRole('textbox', {name: ""})[1] as HTMLInputElement;
    const inputValue2_3 = screen.getAllByRole('textbox', {name: ""})[2] as HTMLInputElement;

    inputValue2_1.focus();
    fireEvent.change(inputValue2_1, {target: {value: '1000000'}})
    inputValue2_1.blur();
    expect(inputValue2_1.value).toBe('1000000');

    inputValue2_2.focus();
    fireEvent.change(inputValue2_2, {target: {value: '住所欄１'}})
    inputValue2_2.blur();
    expect(inputValue2_2.value).toBe('住所欄１');

    inputValue2_3.focus();
    fireEvent.change(inputValue2_3, {target: {value: '住所欄２'}})
    inputValue2_3.blur();
    expect(inputValue2_3.value).toBe('住所欄２');

    const nextButton1 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton1);

    const inputValue2_2_1 = screen.getAllByRole('textbox', {name: ""})[0] as HTMLInputElement;
    const inputValue2_2_2 = screen.getAllByRole('textbox', {name: ""})[1] as HTMLInputElement;
    const inputValue2_3_3 = screen.getAllByRole('textbox', {name: ""})[2] as HTMLInputElement;

    inputValue2_2_1.focus();
    fireEvent.change(inputValue2_2_1, {target: {value: '2000000'}})
    inputValue2_2_1.blur();
    expect(inputValue2_2_1.value).toBe('2000000');

    inputValue2_2_2.focus();
    fireEvent.change(inputValue2_2_2, {target: {value: '住所欄３'}})
    inputValue2_2_2.blur();
    expect(inputValue2_2_2.value).toBe('住所欄３');

    inputValue2_3_3.focus();
    fireEvent.change(inputValue2_3_3, {target: {value: '住所欄４'}})
    inputValue2_3_3.blur();
    expect(inputValue2_3_3.value).toBe('住所欄４');

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);


    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'special(address)_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'special(address)_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: '1000000'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '住所欄１'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '住所欄２'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '2000000'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '住所欄３'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '住所欄４'})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();

    // 編集ボタン
    const editButton = screen.getByRole('link', {name: 'special(address)_short'} );
    fireEvent.click(editButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.special(address)_タイトル"})).toBeInTheDocument();

    expect(screen.getAllByText('special(address)_displayLeft1')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(address)_displayLeft2')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(address)_displayLeft3')[0]).toBeInTheDocument();

    // field
    const textbox2_1 = screen.getAllByRole('textbox', {name: ""})[0] as HTMLInputElement;
    const textbox2_2 = screen.getAllByRole('textbox', {name: ""})[1] as HTMLInputElement;
    const textbox2_3 = screen.getAllByRole('textbox', {name: ""})[2] as HTMLInputElement;

    expect(textbox2_1.value ).toBe('1000000');
    expect(textbox2_1.placeholder).toBe('special(address)_placeholder1');
    expect(textbox2_1.type).toBe('tel');

    expect(textbox2_2.value ).toBe('住所欄１');
    expect(textbox2_2.placeholder).toBe('special(address)_placeholder2');
    expect(textbox2_2.type).toBe('text');

    expect(textbox2_3.value ).toBe('住所欄２');
    expect(textbox2_3.placeholder).toBe('special(address)_placeholder3');
    expect(textbox2_3.type).toBe('text');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.getAllByText('確認画面へ')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const editInputValue2_1 = screen.getAllByRole('textbox', {name: ""})[0] as HTMLInputElement;
    const editInputValue2_2 = screen.getAllByRole('textbox', {name: ""})[1] as HTMLInputElement;
    const editInputValue2_3 = screen.getAllByRole('textbox', {name: ""})[2] as HTMLInputElement;

    editInputValue2_1.focus();
    fireEvent.change(editInputValue2_1, {target: {value: '3000000'}})
    editInputValue2_1.blur();
    expect(editInputValue2_1.value).toBe('3000000');

    editInputValue2_2.focus();
    fireEvent.change(editInputValue2_2, {target: {value: '編集住所１'}})
    editInputValue2_2.blur();
    expect(editInputValue2_2.value).toBe('編集住所１');

    editInputValue2_3.focus();
    fireEvent.change(editInputValue2_3, {target: {value: '編集住所２'}})
    editInputValue2_3.blur();
    expect(editInputValue2_3.value).toBe('編集住所２');

    // 編集ボタン
    const confirmationButton = screen.getAllByText('確認画面へ')[0];
    fireEvent.click(confirmationButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'special(address)_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'special(address)_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: '3000000'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '編集住所１'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '編集住所２'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '2000000'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '住所欄３'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '住所欄４'})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();
  });    

  test('Validation Check', async() => {
    global.alert = jest.fn()
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 4, 
                title: "special(address)_タイトル",
                shortTitle: "special(address)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description1",
                    displayLeft: "special(address)_displayLeft1",
                    displayName: "special(address)_displayName1",
                    displayRight: "special(address)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder1",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2",
                    displayLeft: "special(address)_displayLeft2",
                    displayName: "special(address)_displayName2",
                    displayRight: "special(address)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description3",
                    displayLeft: "special(address)_displayLeft3",
                    displayName: "special(address)_displayName3",
                    displayRight: "special(address)_displayRight3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder3",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 4, 
                questionNumber: 1, 
                shortTitle: "special(address)_short2", 
                template_id: 1, 
                title: "special(address)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-1",
                    displayLeft: "special(address)_displayLeft2-1",
                    displayName: "special(address)_displayName2-1",
                    displayRight: "special(address)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-1",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-2",
                    displayLeft: "special(address)_displayLeft2-2",
                    displayName: "special(address)_displayName2-2",
                    displayRight: "special(address)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-3",
                    displayLeft: "special(address)_displayLeft2-3",
                    displayName: "special(address)_displayName2-3",
                    displayRight: "special(address)_displayRight2-3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-3",
                    options: []
                  }
                ]
              }
            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 4, 
                title: "special(address)_タイトル",
                shortTitle: "special(address)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description1",
                    displayLeft: "special(address)_displayLeft1",
                    displayName: "special(address)_displayName1",
                    displayRight: "special(address)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder1",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2",
                    displayLeft: "special(address)_displayLeft2",
                    displayName: "special(address)_displayName2",
                    displayRight: "special(address)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description3",
                    displayLeft: "special(address)_displayLeft3",
                    displayName: "special(address)_displayName3",
                    displayRight: "special(address)_displayRight3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder3",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 4, 
                questionNumber: 1, 
                shortTitle: "special(address)_short2", 
                template_id: 1, 
                title: "special(address)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-1",
                    displayLeft: "special(address)_displayLeft2-1",
                    displayName: "special(address)_displayName2-1",
                    displayRight: "special(address)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-1",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-2",
                    displayLeft: "special(address)_displayLeft2-2",
                    displayName: "special(address)_displayName2-2",
                    displayRight: "special(address)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(address)_description2-3",
                    displayLeft: "special(address)_displayLeft2-3",
                    displayName: "special(address)_displayName2-3",
                    displayRight: "special(address)_displayRight2-3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(address)_placeholder2-3",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const inputValue2_1 = screen.getAllByRole('textbox', {name: ""})[0] as HTMLInputElement;
    const inputValue2_2 = screen.getAllByRole('textbox', {name: ""})[1] as HTMLInputElement;
    // const inputValue2_3 = screen.getAllByRole('textbox', {name: ""})[2] as HTMLInputElement;

    // 半角ハイフンなし
    inputValue2_1.focus();
    fireEvent.change(inputValue2_1, {target: {value: '1500000'}});
    inputValue2_1.blur();
    expect(inputValue2_1.value).toBe('1500000'); 

    // 半角ハイフンあり -> 半角数字のみに変換されること
    inputValue2_1.focus();
    fireEvent.change(inputValue2_1, {target: {value: '150-0000'}});
    inputValue2_1.blur();
    expect(inputValue2_1.value).toBe('1500000'); 

    // 全角ハイフンなし -> 半角数字のみに変換されること
    inputValue2_1.focus();
    fireEvent.change(inputValue2_1, {target: {value: '１５０００００'}});
    inputValue2_1.blur();
    expect(inputValue2_1.value).toBe('1500000'); 

    // 全角ハイフンあり -> 半角数字のみに変換されること
    inputValue2_1.focus();
    fireEvent.change(inputValue2_1, {target: {value: '１５０ー００００'}});
    inputValue2_1.blur();
    expect(inputValue2_1.value).toBe('1500000'); 

    // 半角全角混じりハイフンなし -> 半角数字のみに変換されること
    inputValue2_1.focus();
    fireEvent.change(inputValue2_1, {target: {value: '1５0０0０0'}});
    inputValue2_1.blur();
    expect(inputValue2_1.value).toBe('1500000'); 

    // 半角全角混じりハイフンあり -> 半角数字のみに変換されること
    inputValue2_1.focus();
    fireEvent.change(inputValue2_1, {target: {value: '1５0ー0０0０'}});
    inputValue2_1.blur();
    expect(inputValue2_1.value).toBe('1500000');

    // ハイフン2（―）
    inputValue2_1.focus();
    fireEvent.change(inputValue2_1, {target: {value: '080―1234―1234'}})
    inputValue2_1.blur();
    expect(inputValue2_1.value).toBe('08012341234');

    // ハイフン3（‐）
    inputValue2_1.focus();
    fireEvent.change(inputValue2_1, {target: {value: '080‐1234‐1234'}})
    inputValue2_1.blur();
    expect(inputValue2_1.value).toBe('08012341234');

    // ハイフン4（－）
    inputValue2_1.focus();
    fireEvent.change(inputValue2_1, {target: {value: '080－1234－1234'}})
    inputValue2_1.blur();
    expect(inputValue2_1.value).toBe('08012341234');

    // ハイフン以外の記号があり、ハイフン削除処理後も半角数字のみにならない -> アラートが出る
    inputValue2_1.focus();
    fireEvent.change(inputValue2_1, {target: {value: '150*0000'}});
    inputValue2_1.blur();
    expect(global.alert).toHaveBeenCalledTimes(1);
    expect(inputValue2_1.value).toBe('');
  });
});

describe('special cigarettes Test', () => {   
  test('Render', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 5, 
                title: "special(cigarettes)_タイトル",
                shortTitle: "special(cigarettes)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description1",
                    displayLeft: "special(cigarettes)_displayLeft1",
                    displayName: "special(cigarettes)_displayName1",
                    displayRight: "special(cigarettes)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "special(cigarettes)_placeholder1",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2",
                    displayLeft: "special(cigarettes)_displayLeft2",
                    displayName: "special(cigarettes)_displayName2",
                    displayRight: "special(cigarettes)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description3",
                    displayLeft: "special(cigarettes)_displayLeft3",
                    displayName: "special(cigarettes)_displayName3",
                    displayRight: "special(cigarettes)_displayRight3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder3",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description4",
                    displayLeft: "special(cigarettes)_displayLeft4",
                    displayName: "special(cigarettes)_displayName4",
                    displayRight: "special(cigarettes)_displayRight4",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder4",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 5, 
                questionNumber: 1, 
                shortTitle: "special(cigarettes)_short2", 
                template_id: 1, 
                title: "special(cigarettes)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-1",
                    displayLeft: "special(cigarettes)_displayLeft2-1",
                    displayName: "special(cigarettes)_displayName2-1",
                    displayRight: "special(cigarettes)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-1",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-2",
                    displayLeft: "special(cigarettes)_displayLeft2-2",
                    displayName: "special(cigarettes)_displayName2-2",
                    displayRight: "special(cigarettes)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-3",
                    displayLeft: "special(cigarettes)_displayLeft2-3",
                    displayName: "special(cigarettes)_displayName2-3",
                    displayRight: "special(cigarettes)_displayRight2-3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-3",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-4",
                    displayLeft: "special(cigarettes)_displayLeft2-4",
                    displayName: "special(cigarettes)_displayName2-4",
                    displayRight: "special(cigarettes)_displayRight2-4",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-4",
                    options: []
                  }
                ]
              }
            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 5, 
                title: "special(cigarettes)_タイトル",
                shortTitle: "special(cigarettes)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description1",
                    displayLeft: "special(cigarettes)_displayLeft1",
                    displayName: "special(cigarettes)_displayName1",
                    displayRight: "special(cigarettes)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "special(cigarettes)_placeholder1",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2",
                    displayLeft: "special(cigarettes)_displayLeft2",
                    displayName: "special(cigarettes)_displayName2",
                    displayRight: "special(cigarettes)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description3",
                    displayLeft: "special(cigarettes)_displayLeft3",
                    displayName: "special(cigarettes)_displayName3",
                    displayRight: "special(cigarettes)_displayRight3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder3",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description4",
                    displayLeft: "special(cigarettes)_displayLeft4",
                    displayName: "special(cigarettes)_displayName4",
                    displayRight: "special(cigarettes)_displayRight4",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder4",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 5, 
                questionNumber: 1, 
                shortTitle: "special(cigarettes)_short2", 
                template_id: 1, 
                title: "special(cigarettes)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-1",
                    displayLeft: "special(cigarettes)_displayLeft2-1",
                    displayName: "special(cigarettes)_displayName2-1",
                    displayRight: "special(cigarettes)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-1",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-2",
                    displayLeft: "special(cigarettes)_displayLeft2-2",
                    displayName: "special(cigarettes)_displayName2-2",
                    displayRight: "special(cigarettes)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-3",
                    displayLeft: "special(cigarettes)_displayLeft2-3",
                    displayName: "special(cigarettes)_displayName2-3",
                    displayRight: "special(cigarettes)_displayRight2-3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-3",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-4",
                    displayLeft: "special(cigarettes)_displayLeft2-4",
                    displayName: "special(cigarettes)_displayName2-4",
                    displayRight: "special(cigarettes)_displayRight2-4",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-4",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.special(cigarettes)_タイトル"})).toBeInTheDocument();
    expect(screen.getAllByText('special(cigarettes)_displayLeft2')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(cigarettes)_displayLeft3')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(cigarettes)_displayLeft4')[0]).toBeInTheDocument();

    expect(screen.getAllByText('special(cigarettes)_displayRight2')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(cigarettes)_displayRight3')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(cigarettes)_displayRight4')[0]).toBeInTheDocument();

    // field
    const radio1_1 = screen.getAllByRole('radio', {name: "オプション1_1"})[0] as HTMLInputElement;
    expect(radio1_1.value ).toBe('1,オプション1_1');
    expect(radio1_1.type).toBe('radio');

    const radio1_2 = screen.getAllByRole('radio', {name: "オプション1_2"})[0] as HTMLInputElement;
    expect(radio1_2.value ).toBe('2,オプション1_2');
    expect(radio1_2.type).toBe('radio');

    const radio1_3 = screen.getAllByRole('radio', {name: "オプション1_3"})[0] as HTMLInputElement;
    expect(radio1_3.value ).toBe('3,オプション1_3');
    expect(radio1_3.type).toBe('radio');


    const textbox2_2 = screen.getAllByRole('spinbutton', {name: ""})[0] as HTMLInputElement;
    const textbox2_3 = screen.getAllByRole('spinbutton', {name: ""})[1] as HTMLInputElement;
    const textbox2_4 = screen.getAllByRole('spinbutton', {name: ""})[2] as HTMLInputElement;
    
    expect(textbox2_2.value ).toBe('');
    expect(textbox2_2.placeholder).toBe('special(cigarettes)_placeholder2');
    expect(textbox2_2.type).toBe('number');
    expect(textbox2_2).toBeDisabled();

    expect(textbox2_3.value ).toBe('');
    expect(textbox2_3.placeholder).toBe('special(cigarettes)_placeholder3');
    expect(textbox2_3.type).toBe('number');
    expect(textbox2_3).toBeDisabled();

    expect(textbox2_4.value ).toBe('');
    expect(textbox2_4.placeholder).toBe('special(cigarettes)_placeholder4');
    expect(textbox2_4.type).toBe('number');
    expect(textbox2_4).toBeDisabled();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Back Question', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 5, 
                title: "special(cigarettes)_タイトル",
                shortTitle: "special(cigarettes)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description1",
                    displayLeft: "special(cigarettes)_displayLeft1",
                    displayName: "special(cigarettes)_displayName1",
                    displayRight: "special(cigarettes)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "special(cigarettes)_placeholder1",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2",
                    displayLeft: "special(cigarettes)_displayLeft2",
                    displayName: "special(cigarettes)_displayName2",
                    displayRight: "special(cigarettes)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description3",
                    displayLeft: "special(cigarettes)_displayLeft3",
                    displayName: "special(cigarettes)_displayName3",
                    displayRight: "special(cigarettes)_displayRight3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder3",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description4",
                    displayLeft: "special(cigarettes)_displayLeft4",
                    displayName: "special(cigarettes)_displayName4",
                    displayRight: "special(cigarettes)_displayRight4",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder4",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 5, 
                questionNumber: 1, 
                shortTitle: "special(cigarettes)_short2", 
                template_id: 1, 
                title: "special(cigarettes)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-1",
                    displayLeft: "special(cigarettes)_displayLeft2-1",
                    displayName: "special(cigarettes)_displayName2-1",
                    displayRight: "special(cigarettes)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-1",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-2",
                    displayLeft: "special(cigarettes)_displayLeft2-2",
                    displayName: "special(cigarettes)_displayName2-2",
                    displayRight: "special(cigarettes)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-3",
                    displayLeft: "special(cigarettes)_displayLeft2-3",
                    displayName: "special(cigarettes)_displayName2-3",
                    displayRight: "special(cigarettes)_displayRight2-3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-3",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-4",
                    displayLeft: "special(cigarettes)_displayLeft2-4",
                    displayName: "special(cigarettes)_displayName2-4",
                    displayRight: "special(cigarettes)_displayRight2-4",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-4",
                    options: []
                  }
                ]
              }
            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 5, 
                title: "special(cigarettes)_タイトル",
                shortTitle: "special(cigarettes)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description1",
                    displayLeft: "special(cigarettes)_displayLeft1",
                    displayName: "special(cigarettes)_displayName1",
                    displayRight: "special(cigarettes)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "special(cigarettes)_placeholder1",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2",
                    displayLeft: "special(cigarettes)_displayLeft2",
                    displayName: "special(cigarettes)_displayName2",
                    displayRight: "special(cigarettes)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description3",
                    displayLeft: "special(cigarettes)_displayLeft3",
                    displayName: "special(cigarettes)_displayName3",
                    displayRight: "special(cigarettes)_displayRight3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder3",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description4",
                    displayLeft: "special(cigarettes)_displayLeft4",
                    displayName: "special(cigarettes)_displayName4",
                    displayRight: "special(cigarettes)_displayRight4",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder4",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 5, 
                questionNumber: 1, 
                shortTitle: "special(cigarettes)_short2", 
                template_id: 1, 
                title: "special(cigarettes)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-1",
                    displayLeft: "special(cigarettes)_displayLeft2-1",
                    displayName: "special(cigarettes)_displayName2-1",
                    displayRight: "special(cigarettes)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-1",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-2",
                    displayLeft: "special(cigarettes)_displayLeft2-2",
                    displayName: "special(cigarettes)_displayName2-2",
                    displayRight: "special(cigarettes)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-3",
                    displayLeft: "special(cigarettes)_displayLeft2-3",
                    displayName: "special(cigarettes)_displayName2-3",
                    displayRight: "special(cigarettes)_displayRight2-3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-3",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-4",
                    displayLeft: "special(cigarettes)_displayLeft2-4",
                    displayName: "special(cigarettes)_displayName2-4",
                    displayRight: "special(cigarettes)_displayRight2-4",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-4",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    // それぞれのラジオボタンをクリックした時の動きをテストしてから、質問の行き来のテストを行う（ここではオプション1-3の選択状態で次の質問へ進む）

    const radio1_1 = screen.getAllByRole('radio', {name: "オプション1_1"})[0] as HTMLInputElement;
    const radio1_2 = screen.getAllByRole('radio', {name: "オプション1_2"})[0] as HTMLInputElement;
    const radio1_3 = screen.getAllByRole('radio', {name: "オプション1_3"})[0] as HTMLInputElement;
    const inputValue2_1 = screen.getAllByRole('spinbutton', {name: ""})[0] as HTMLInputElement;
    const inputValue2_2 = screen.getAllByRole('spinbutton', {name: ""})[1] as HTMLInputElement;
    const inputValue2_3 = screen.getAllByRole('spinbutton', {name: ""})[2] as HTMLInputElement;

    // オプション1-1（吸わない）が選択された時は数値の入力ができない、全ての数値入力欄のvalueが空になる
    expect(radio1_1).not.toBeChecked();
    fireEvent.click(radio1_1);
    expect(radio1_1).toBeChecked();

    expect(inputValue2_1).toBeDisabled();
    expect(inputValue2_2).toBeDisabled();
    expect(inputValue2_3).toBeDisabled();
    expect(inputValue2_1.value).toBe('');
    expect(inputValue2_2.value).toBe('');
    expect(inputValue2_3.value).toBe('');

    // オプション1-2（禁煙した）が選択された時はinputValue2_1とinputValue2_2のみ入力ができる、3つ目の数値入力欄のvalueが空になる
    expect(radio1_2).not.toBeChecked();
    fireEvent.click(radio1_2);
    expect(radio1_2).toBeChecked();

    expect(inputValue2_1).not.toBeDisabled();
    expect(inputValue2_2).not.toBeDisabled();
    expect(inputValue2_3).toBeDisabled();
    expect(inputValue2_3.value).toBe('');

    inputValue2_1.focus();
    fireEvent.change(inputValue2_1, {target: {value: '2000'}}) // ここでは数値の範囲をテストしないが数値は適切なものを扱う
    inputValue2_1.blur();
    expect(inputValue2_1.value).toBe('2000');

    inputValue2_2.focus();
    fireEvent.change(inputValue2_2, {target: {value: '20'}})
    inputValue2_2.blur();
    expect(inputValue2_2.value).toBe('20');

    // オプション1-3（吸う）が選択された時はinputValue2_3のみ入力ができる、1つ目と2つ目の数値入力欄のvalueが空になる
    expect(radio1_3).not.toBeChecked();
    fireEvent.click(radio1_3);
    expect(radio1_3).toBeChecked();

    expect(inputValue2_1).toBeDisabled();
    expect(inputValue2_2).toBeDisabled();
    expect(inputValue2_3).not.toBeDisabled();
    expect(inputValue2_1.value).toBe('');
    expect(inputValue2_2.value).toBe('');

    inputValue2_3.focus();
    fireEvent.change(inputValue2_3, {target: {value: '30'}})
    inputValue2_3.blur();
    expect(inputValue2_3.value).toBe('30');

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(2/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.special(cigarettes)_タイトル2"})).toBeInTheDocument();
    expect(screen.getAllByText('special(cigarettes)_displayLeft2-2')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(cigarettes)_displayLeft2-3')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(cigarettes)_displayLeft2-4')[0]).toBeInTheDocument();

    expect(screen.getAllByText('special(cigarettes)_displayRight2-2')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(cigarettes)_displayRight2-3')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(cigarettes)_displayRight2-4')[0]).toBeInTheDocument();

    // field
    const radio2_1 = screen.getAllByRole('radio', {name: "オプション2_1"})[0] as HTMLInputElement;
    expect(radio2_1.value ).toBe('1,オプション2_1');
    expect(radio2_1.type).toBe('radio');

    const radio2_2 = screen.getAllByRole('radio', {name: "オプション2_2"})[0] as HTMLInputElement;
    expect(radio2_2.value ).toBe('2,オプション2_2');
    expect(radio2_2.type).toBe('radio');

    const radio2_3 = screen.getAllByRole('radio', {name: "オプション2_3"})[0] as HTMLInputElement;
    expect(radio2_3.value ).toBe('3,オプション2_3');
    expect(radio2_3.type).toBe('radio');

    // field
    const textbox2_2 = screen.getAllByRole('spinbutton', {name: ""})[0] as HTMLInputElement;
    const textbox2_3 = screen.getAllByRole('spinbutton', {name: ""})[1] as HTMLInputElement;
    const textbox2_4 = screen.getAllByRole('spinbutton', {name: ""})[2] as HTMLInputElement;
    
    expect(textbox2_2.value ).toBe('');
    expect(textbox2_2.placeholder).toBe('special(cigarettes)_placeholder2-2');
    expect(textbox2_2.type).toBe('number');
    expect(textbox2_2).toBeDisabled(); // 何も選択されていない状態では数値入力欄はdisabledになっていること

    expect(textbox2_3.value ).toBe('');
    expect(textbox2_3.placeholder).toBe('special(cigarettes)_placeholder2-3');
    expect(textbox2_3.type).toBe('number');
    expect(textbox2_3).toBeDisabled(); // 何も選択されていない状態では数値入力欄はdisabledになっていること

    expect(textbox2_4.value ).toBe('');
    expect(textbox2_4.placeholder).toBe('special(cigarettes)_placeholder2-4');
    expect(textbox2_4.type).toBe('number');
    expect(textbox2_4).toBeDisabled(); // 何も選択されていない状態では数値入力欄はdisabledになっていること

    // button
    expect(screen.queryAllByText('戻る')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const backButton2 = screen.queryAllByText('戻る')[0];
    fireEvent.click(backButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.special(cigarettes)_タイトル"})).toBeInTheDocument();
    expect(screen.getAllByText('special(cigarettes)_displayLeft2')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(cigarettes)_displayLeft3')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(cigarettes)_displayLeft4')[0]).toBeInTheDocument();

    expect(screen.getAllByText('special(cigarettes)_displayRight2')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(cigarettes)_displayRight3')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(cigarettes)_displayRight4')[0]).toBeInTheDocument();

    // field
    const backradio1_1 = screen.getAllByRole('radio', {name: "オプション1_1"})[0] as HTMLInputElement;
    expect(backradio1_1.value ).toBe('1,オプション1_1');
    expect(backradio1_1.type).toBe('radio');
    expect(backradio1_1).not.toBeChecked();

    const backradio1_2 = screen.getAllByRole('radio', {name: "オプション1_2"})[0] as HTMLInputElement;
    expect(backradio1_2.value ).toBe('2,オプション1_2');
    expect(backradio1_2.type).toBe('radio');
    expect(backradio1_2).not.toBeChecked();

    const backradio1_3 = screen.getAllByRole('radio', {name: "オプション1_3"})[0] as HTMLInputElement;
    expect(backradio1_3.value ).toBe('3,オプション1_3');
    expect(backradio1_3.type).toBe('radio');
    expect(backradio1_3).toBeChecked();

    // field
    const backtextbox2_2 = screen.getAllByRole('spinbutton', {name: ""})[0] as HTMLInputElement;
    const backtextbox2_3 = screen.getAllByRole('spinbutton', {name: ""})[1] as HTMLInputElement;
    const backtextbox2_4 = screen.getAllByRole('spinbutton', {name: ""})[2] as HTMLInputElement;
    
    expect(backtextbox2_2.value ).toBe('');
    expect(backtextbox2_2.placeholder).toBe('special(cigarettes)_placeholder2');
    expect(backtextbox2_2.type).toBe('number');
    expect(backtextbox2_2).toBeDisabled();

    expect(backtextbox2_3.value ).toBe('');
    expect(backtextbox2_3.placeholder).toBe('special(cigarettes)_placeholder3');
    expect(backtextbox2_3.type).toBe('number');
    expect(backtextbox2_3).toBeDisabled();

    expect(backtextbox2_4.value ).toBe('30');
    expect(backtextbox2_4.placeholder).toBe('special(cigarettes)_placeholder4');
    expect(backtextbox2_4.type).toBe('number');
    expect(backtextbox2_4).not.toBeDisabled();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Confirmation', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 5, 
                title: "special(cigarettes)_タイトル",
                shortTitle: "special(cigarettes)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description1",
                    displayLeft: "special(cigarettes)_displayLeft1",
                    displayName: "special(cigarettes)_displayName1",
                    displayRight: "special(cigarettes)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "special(cigarettes)_placeholder1",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2",
                    displayLeft: "special(cigarettes)_displayLeft2",
                    displayName: "special(cigarettes)_displayName2",
                    displayRight: "special(cigarettes)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description3",
                    displayLeft: "special(cigarettes)_displayLeft3",
                    displayName: "special(cigarettes)_displayName3",
                    displayRight: "special(cigarettes)_displayRight3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder3",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description4",
                    displayLeft: "special(cigarettes)_displayLeft4",
                    displayName: "special(cigarettes)_displayName4",
                    displayRight: "special(cigarettes)_displayRight4",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder4",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 5, 
                questionNumber: 1, 
                shortTitle: "special(cigarettes)_short2", 
                template_id: 1, 
                title: "special(cigarettes)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-1",
                    displayLeft: "special(cigarettes)_displayLeft2-1",
                    displayName: "special(cigarettes)_displayName2-1",
                    displayRight: "special(cigarettes)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-1",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-2",
                    displayLeft: "special(cigarettes)_displayLeft2-2",
                    displayName: "special(cigarettes)_displayName2-2",
                    displayRight: "special(cigarettes)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-3",
                    displayLeft: "special(cigarettes)_displayLeft2-3",
                    displayName: "special(cigarettes)_displayName2-3",
                    displayRight: "special(cigarettes)_displayRight2-3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-3",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-4",
                    displayLeft: "special(cigarettes)_displayLeft2-4",
                    displayName: "special(cigarettes)_displayName2-4",
                    displayRight: "special(cigarettes)_displayRight2-4",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-4",
                    options: []
                  }
                ]
              }
            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 5, 
                title: "special(cigarettes)_タイトル",
                shortTitle: "special(cigarettes)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description1",
                    displayLeft: "special(cigarettes)_displayLeft1",
                    displayName: "special(cigarettes)_displayName1",
                    displayRight: "special(cigarettes)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "special(cigarettes)_placeholder1",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2",
                    displayLeft: "special(cigarettes)_displayLeft2",
                    displayName: "special(cigarettes)_displayName2",
                    displayRight: "special(cigarettes)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description3",
                    displayLeft: "special(cigarettes)_displayLeft3",
                    displayName: "special(cigarettes)_displayName3",
                    displayRight: "special(cigarettes)_displayRight3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder3",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description4",
                    displayLeft: "special(cigarettes)_displayLeft4",
                    displayName: "special(cigarettes)_displayName4",
                    displayRight: "special(cigarettes)_displayRight4",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder4",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 5, 
                questionNumber: 1, 
                shortTitle: "special(cigarettes)_short2", 
                template_id: 1, 
                title: "special(cigarettes)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-1",
                    displayLeft: "special(cigarettes)_displayLeft2-1",
                    displayName: "special(cigarettes)_displayName2-1",
                    displayRight: "special(cigarettes)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-1",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-2",
                    displayLeft: "special(cigarettes)_displayLeft2-2",
                    displayName: "special(cigarettes)_displayName2-2",
                    displayRight: "special(cigarettes)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-2",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-3",
                    displayLeft: "special(cigarettes)_displayLeft2-3",
                    displayName: "special(cigarettes)_displayName2-3",
                    displayRight: "special(cigarettes)_displayRight2-3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-3",
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-4",
                    displayLeft: "special(cigarettes)_displayLeft2-4",
                    displayName: "special(cigarettes)_displayName2-4",
                    displayRight: "special(cigarettes)_displayRight2-4",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-4",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const radio1_2 = screen.getAllByRole('radio', {name: "オプション1_2"})[0] as HTMLInputElement;
    expect(radio1_2).not.toBeChecked();
    fireEvent.click(radio1_2);
    expect(radio1_2).toBeChecked();

    const inputValue2_1 = screen.getAllByRole('spinbutton', {name: ""})[0] as HTMLInputElement;
    const inputValue2_2 = screen.getAllByRole('spinbutton', {name: ""})[1] as HTMLInputElement;
    const inputValue2_3 = screen.getAllByRole('spinbutton', {name: ""})[2] as HTMLInputElement;

    // 2つ目の選択肢（radio1_2）を選択したので、1つ目と2つ目の数値入力欄が入力できることを確認
    expect(inputValue2_1).not.toBeDisabled();
    expect(inputValue2_2).not.toBeDisabled();
    expect(inputValue2_3).toBeDisabled();

    inputValue2_1.focus();
    fireEvent.change(inputValue2_1, {target: {value: '2000'}}) // ここでは数値の範囲をテストしないが数値は適切なものを扱う
    inputValue2_1.blur();
    expect(inputValue2_1.value).toBe('2000');

    inputValue2_2.focus();
    fireEvent.change(inputValue2_2, {target: {value: '20'}})
    inputValue2_2.blur();
    expect(inputValue2_2.value).toBe('20');

    const nextButton1 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton1);

    const radio2_3 = screen.getAllByRole('radio', {name: "オプション2_3"})[0] as HTMLInputElement;
    expect(radio2_3).not.toBeChecked();
    fireEvent.click(radio2_3);
    expect(radio2_3).toBeChecked();

    const inputValue2_1_1 = screen.getAllByRole('spinbutton', {name: ""})[0] as HTMLInputElement;
    const inputValue2_1_2 = screen.getAllByRole('spinbutton', {name: ""})[1] as HTMLInputElement;
    const inputValue2_1_3 = screen.getAllByRole('spinbutton', {name: ""})[2] as HTMLInputElement;

    // 3つ目の選択肢（radio2_3）を選択したので、3つ目の数値入力欄が入力できることを確認
    expect(inputValue2_1_1).toBeDisabled();
    expect(inputValue2_1_2).toBeDisabled();
    expect(inputValue2_1_3).not.toBeDisabled();

    inputValue2_1_3.focus();
    fireEvent.change(inputValue2_1_3, {target: {value: '60'}})
    inputValue2_1_3.blur();
    expect(inputValue2_1_3.value).toBe('60');

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);


    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'special(cigarettes)_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'special(cigarettes)_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'オプション1_2'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '2000'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '20'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'オプション2_3'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '60'})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();

    // 編集ボタン
    const editButton = screen.getByRole('link', {name: 'special(cigarettes)_short'} );
    fireEvent.click(editButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.special(cigarettes)_タイトル"})).toBeInTheDocument();
    expect(screen.getAllByText('special(cigarettes)_displayLeft2')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(cigarettes)_displayLeft3')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(cigarettes)_displayLeft4')[0]).toBeInTheDocument();

    expect(screen.getAllByText('special(cigarettes)_displayRight2')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(cigarettes)_displayRight3')[0]).toBeInTheDocument();
    expect(screen.getAllByText('special(cigarettes)_displayRight4')[0]).toBeInTheDocument();

    // field
    const backradio1_1 = screen.getAllByRole('radio', {name: "オプション1_1"})[0] as HTMLInputElement;
    expect(backradio1_1.value ).toBe('1,オプション1_1');
    expect(backradio1_1.type).toBe('radio');
    expect(backradio1_1).not.toBeChecked();

    const backradio1_2 = screen.getAllByRole('radio', {name: "オプション1_2"})[0] as HTMLInputElement;
    expect(backradio1_2.value ).toBe('2,オプション1_2');
    expect(backradio1_2.type).toBe('radio');
    expect(backradio1_2).toBeChecked();

    const backradio1_3 = screen.getAllByRole('radio', {name: "オプション1_3"})[0] as HTMLInputElement;
    expect(backradio1_3.value ).toBe('3,オプション1_3');
    expect(backradio1_3.type).toBe('radio');
    expect(backradio1_3).not.toBeChecked();

    // field
    const backtextbox2_2 = screen.getAllByRole('spinbutton', {name: ""})[0] as HTMLInputElement;
    const backtextbox2_3 = screen.getAllByRole('spinbutton', {name: ""})[1] as HTMLInputElement;
    const backtextbox2_4 = screen.getAllByRole('spinbutton', {name: ""})[2] as HTMLInputElement;
    
    expect(backtextbox2_2.value ).toBe('2000');
    expect(backtextbox2_2.placeholder).toBe('special(cigarettes)_placeholder2');
    expect(backtextbox2_2.type).toBe('number');
    expect(backtextbox2_2).not.toBeDisabled();

    expect(backtextbox2_3.value ).toBe('20');
    expect(backtextbox2_3.placeholder).toBe('special(cigarettes)_placeholder3');
    expect(backtextbox2_3.type).toBe('number');
    expect(backtextbox2_3).not.toBeDisabled();

    expect(backtextbox2_4.value ).toBe('');
    expect(backtextbox2_4.placeholder).toBe('special(cigarettes)_placeholder4');
    expect(backtextbox2_4.type).toBe('number');
    expect(backtextbox2_4).toBeDisabled();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.getAllByText('確認画面へ')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    // 2つ目の選択肢から3つ目の選択肢へ変更
    const editradio1_3 = screen.getAllByRole('radio', {name: "オプション1_3"})[0] as HTMLInputElement;
    expect(editradio1_3).not.toBeChecked();
    fireEvent.click(editradio1_3);
    expect(editradio1_3).toBeChecked();

    const editinputValue2_1 = screen.getAllByRole('spinbutton', {name: ""})[0] as HTMLInputElement;
    const editinputValue2_2 = screen.getAllByRole('spinbutton', {name: ""})[1] as HTMLInputElement;
    const editinputValue2_3 = screen.getAllByRole('spinbutton', {name: ""})[2] as HTMLInputElement;

    // 3つ目の選択肢（editradio2_3）を選択したので、3つ目の数値入力欄が入力できることを確認、1つ目と2つ目の数値入力欄が空になっていることを確認
    expect(editinputValue2_1).toBeDisabled();
    expect(editinputValue2_2).toBeDisabled();
    expect(editinputValue2_3).not.toBeDisabled();
    expect(editinputValue2_1.value).toBe('');
    expect(editinputValue2_2.value).toBe('');

    editinputValue2_3.focus();
    fireEvent.change(editinputValue2_3, {target: {value: '90'}})
    editinputValue2_3.blur();
    expect(editinputValue2_3.value).toBe('90');

    // 編集ボタン
    const confirmationButton = screen.getAllByText('確認画面へ')[0];
    fireEvent.click(confirmationButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'special(cigarettes)_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'special(cigarettes)_short2'})).toBeInTheDocument();

    expect(screen.queryByText('2000')).not.toBeInTheDocument();
    expect(screen.queryByText('20')).not.toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'オプション1_3'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '60'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'オプション2_3'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '90'})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();
  });    

  test('Validation Check', async() => {
    global.alert = jest.fn()
    
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 5, 
                title: "special(cigarettes)_タイトル",
                shortTitle: "special(cigarettes)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description1",
                    displayLeft: "special(cigarettes)_displayLeft1",
                    displayName: "special(cigarettes)_displayName1",
                    displayRight: "special(cigarettes)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "special(cigarettes)_placeholder1",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2",
                    displayLeft: "special(cigarettes)_displayLeft2",
                    displayName: "special(cigarettes)_displayName2",
                    displayRight: "special(cigarettes)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2",
                    validateValueMax: null,
                    validateValueMin: 1900,
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description3",
                    displayLeft: "special(cigarettes)_displayLeft3",
                    displayName: "special(cigarettes)_displayName3",
                    displayRight: "special(cigarettes)_displayRight3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder3",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description4",
                    displayLeft: "special(cigarettes)_displayLeft4",
                    displayName: "special(cigarettes)_displayName4",
                    displayRight: "special(cigarettes)_displayRight4",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder4",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 5, 
                questionNumber: 1, 
                shortTitle: "special(cigarettes)_short2", 
                template_id: 1, 
                title: "special(cigarettes)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-1",
                    displayLeft: "special(cigarettes)_displayLeft2-1",
                    displayName: "special(cigarettes)_displayName2-1",
                    displayRight: "special(cigarettes)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-1",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-2",
                    displayLeft: "special(cigarettes)_displayLeft2-2",
                    displayName: "special(cigarettes)_displayName2-2",
                    displayRight: "special(cigarettes)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-2",
                    validateValueMax: null,
                    validateValueMin: 1900,
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-3",
                    displayLeft: "special(cigarettes)_displayLeft2-3",
                    displayName: "special(cigarettes)_displayName2-3",
                    displayRight: "special(cigarettes)_displayRight2-3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-3",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-4",
                    displayLeft: "special(cigarettes)_displayLeft2-4",
                    displayName: "special(cigarettes)_displayName2-4",
                    displayRight: "special(cigarettes)_displayRight2-4",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-4",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: []
                  }
                ]
              }
            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 5, 
                title: "special(cigarettes)_タイトル",
                shortTitle: "special(cigarettes)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description1",
                    displayLeft: "special(cigarettes)_displayLeft1",
                    displayName: "special(cigarettes)_displayName1",
                    displayRight: "special(cigarettes)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "special(cigarettes)_placeholder1",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2",
                    displayLeft: "special(cigarettes)_displayLeft2",
                    displayName: "special(cigarettes)_displayName2",
                    displayRight: "special(cigarettes)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2",
                    validateValueMax: null,
                    validateValueMin: 1900,
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description3",
                    displayLeft: "special(cigarettes)_displayLeft3",
                    displayName: "special(cigarettes)_displayName3",
                    displayRight: "special(cigarettes)_displayRight3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder3",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description4",
                    displayLeft: "special(cigarettes)_displayLeft4",
                    displayName: "special(cigarettes)_displayName4",
                    displayRight: "special(cigarettes)_displayRight4",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder4",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 5, 
                questionNumber: 1, 
                shortTitle: "special(cigarettes)_short2", 
                template_id: 1, 
                title: "special(cigarettes)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-1",
                    displayLeft: "special(cigarettes)_displayLeft2-1",
                    displayName: "special(cigarettes)_displayName2-1",
                    displayRight: "special(cigarettes)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-1",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-2",
                    displayLeft: "special(cigarettes)_displayLeft2-2",
                    displayName: "special(cigarettes)_displayName2-2",
                    displayRight: "special(cigarettes)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-2",
                    validateValueMax: null,
                    validateValueMin: 1900,
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-3",
                    displayLeft: "special(cigarettes)_displayLeft2-3",
                    displayName: "special(cigarettes)_displayName2-3",
                    displayRight: "special(cigarettes)_displayRight2-3",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-3",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: []
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(cigarettes)_description2-4",
                    displayLeft: "special(cigarettes)_displayLeft2-4",
                    displayName: "special(cigarettes)_displayName2-4",
                    displayRight: "special(cigarettes)_displayRight2-4",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(cigarettes)_placeholder2-4",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    // 1つ目の選択肢は何も入力できなくなる為ここでは使用しない
    const radio1_2 = screen.getAllByRole('radio', {name: "オプション1_2"})[0] as HTMLInputElement;
    const radio1_3 = screen.getAllByRole('radio', {name: "オプション1_3"})[0] as HTMLInputElement;

    const textbox2_2 = screen.getAllByRole('spinbutton', {name: ""})[0] as HTMLInputElement;
    const textbox2_3 = screen.getAllByRole('spinbutton', {name: ""})[1] as HTMLInputElement;
    const textbox2_4 = screen.getAllByRole('spinbutton', {name: ""})[2] as HTMLInputElement;

    // 2つ目の選択肢を選択して、1つ目と2つ目の数値入力欄のバリデーションを確認
    expect(radio1_2).not.toBeChecked();
    fireEvent.click(radio1_2);
    expect(radio1_2).toBeChecked();

    expect(textbox2_2).not.toBeDisabled();
    expect(textbox2_3).not.toBeDisabled();
    expect(textbox2_4).toBeDisabled();

    // 1つ目の数値入力欄は最小値1900、最大値nullを設定
    textbox2_2.focus();
    fireEvent.change(textbox2_2, {target: {value: '1899'}});
    textbox2_2.blur();
    expect(global.alert).toHaveBeenCalledTimes(1);
    expect(textbox2_2.value).toBe('');

    textbox2_2.focus();
    fireEvent.change(textbox2_2, {target: {value: '1900'}});
    textbox2_2.blur();
    expect(global.alert).toHaveBeenCalledTimes(1); // 範囲内の値を入力した時はインクリメントされないことを確認
    expect(textbox2_2.value).toBe('1900');

    // 2つ目の数値入力欄は最小値0、最大値999を設定
    textbox2_3.focus();
    fireEvent.change(textbox2_3, {target: {value: '-1'}});
    textbox2_3.blur();
    expect(global.alert).toHaveBeenCalledTimes(2);
    expect(textbox2_3.value).toBe('');

    textbox2_3.focus();
    fireEvent.change(textbox2_3, {target: {value: '1000'}});
    textbox2_3.blur();
    expect(global.alert).toHaveBeenCalledTimes(3);
    expect(textbox2_3.value).toBe('');

    textbox2_3.focus();
    fireEvent.change(textbox2_3, {target: {value: '0'}});
    textbox2_3.blur();
    expect(global.alert).toHaveBeenCalledTimes(3); // 範囲内の値を入力した時はインクリメントされないことを確認
    expect(textbox2_3.value).toBe('0');

    textbox2_3.focus();
    fireEvent.change(textbox2_3, {target: {value: '999'}});
    textbox2_3.blur();
    expect(global.alert).toHaveBeenCalledTimes(3); // 範囲内の値を入力した時はインクリメントされないことを確認
    expect(textbox2_3.value).toBe('999');

    // 3つ目の選択肢を選択して、3つ目の数値入力欄のバリデーションを確認
    expect(radio1_3).not.toBeChecked();
    fireEvent.click(radio1_3);
    expect(radio1_3).toBeChecked();

    expect(textbox2_2).toBeDisabled();
    expect(textbox2_3).toBeDisabled();
    expect(textbox2_4).not.toBeDisabled();
    expect(textbox2_2.value).toBe('');
    expect(textbox2_3.value).toBe('');

    // 3つ目の数値入力欄の最小値は0、最大値は999を設定
    textbox2_4.focus();
    fireEvent.change(textbox2_4, {target: {value: '-1'}});
    textbox2_4.blur();
    expect(global.alert).toHaveBeenCalledTimes(4);
    expect(textbox2_4.value).toBe('');

    textbox2_4.focus();
    fireEvent.change(textbox2_4, {target: {value: '1000'}});
    textbox2_4.blur();
    expect(global.alert).toHaveBeenCalledTimes(5);
    expect(textbox2_4.value).toBe('');

    textbox2_4.focus();
    fireEvent.change(textbox2_4, {target: {value: '0'}}); 
    textbox2_4.blur();
    expect(global.alert).toHaveBeenCalledTimes(5); // 範囲内の値を入力した時はインクリメントされないことを確認
    expect(textbox2_4.value).toBe('0');

    textbox2_4.focus();
    fireEvent.change(textbox2_4, {target: {value: '999'}}); 
    textbox2_4.blur();
    expect(global.alert).toHaveBeenCalledTimes(5); // 範囲内の値を入力した時はインクリメントされないことを確認
    expect(textbox2_4.value).toBe('999');
  });
});

describe('special pregnancy Test', () => {   
  test('Render', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 6, 
                title: "special(pregnancy)タイトル",
                shortTitle: "special(pregnancy)short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description1",
                    displayLeft: "special(pregnancy)displayLeft1",
                    displayName: "special(pregnancy)displayName1",
                    displayRight: "special(pregnancy)displayRight1",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "special(pregnancy)placeholder1",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description2",
                    displayLeft: "special(pregnancy)displayLeft2",
                    displayName: "special(pregnancy)displayName2",
                    displayRight: "special(pregnancy)displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(pregnancy)placeholder2",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 6, 
                questionNumber: 1, 
                shortTitle: "special(pregnancy)short2", 
                template_id: 1, 
                title: "special(pregnancy)タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description2-1",
                    displayLeft: "special(pregnancy)displayLeft2-1",
                    displayName: "special(pregnancy)displayName2-1",
                    displayRight: "special(pregnancy)displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(pregnancy)placeholder2-1",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description2-2",
                    displayLeft: "special(pregnancy)displayLeft2-2",
                    displayName: "special(pregnancy)displayName2-2",
                    displayRight: "special(pregnancy)displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(pregnancy)placeholder2-2",
                    options: []
                  }
                ]
              }
            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 6, 
                title: "special(pregnancy)タイトル",
                shortTitle: "special(pregnancy)short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description1",
                    displayLeft: "special(pregnancy)displayLeft1",
                    displayName: "special(pregnancy)displayName1",
                    displayRight: "special(pregnancy)displayRight1",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "special(pregnancy)placeholder1",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description2",
                    displayLeft: "special(pregnancy)displayLeft2",
                    displayName: "special(pregnancy)displayName2",
                    displayRight: "special(pregnancy)displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(pregnancy)placeholder2",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 6, 
                questionNumber: 1, 
                shortTitle: "special(pregnancy)short2", 
                template_id: 1, 
                title: "special(pregnancy)タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description2-1",
                    displayLeft: "special(pregnancy)displayLeft2-1",
                    displayName: "special(pregnancy)displayName2-1",
                    displayRight: "special(pregnancy)displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(pregnancy)placeholder2-1",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description2-2",
                    displayLeft: "special(pregnancy)displayLeft2-2",
                    displayName: "special(pregnancy)displayName2-2",
                    displayRight: "special(pregnancy)displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(pregnancy)placeholder2-2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.special(pregnancy)タイトル"})).toBeInTheDocument();
    expect(screen.getAllByText('special(pregnancy)displayLeft2')[0]).toBeInTheDocument();

    // field
    const radio1_1 = screen.getAllByRole('radio', {name: "オプション1_1"})[0] as HTMLInputElement;
    expect(radio1_1.value ).toBe('1,オプション1_1');
    expect(radio1_1.type).toBe('radio');

    const radio1_2 = screen.getAllByRole('radio', {name: "オプション1_2"})[0] as HTMLInputElement;
    expect(radio1_2.value ).toBe('2,オプション1_2');
    expect(radio1_2.type).toBe('radio');

    const radio1_3 = screen.getAllByRole('radio', {name: "オプション1_3"})[0] as HTMLInputElement;
    expect(radio1_3.value ).toBe('3,オプション1_3');
    expect(radio1_3.type).toBe('radio');


    const textbox2_2 = screen.getAllByPlaceholderText('special(pregnancy)placeholder2')[0] as HTMLInputElement;

    
    expect(textbox2_2.value ).toBe('');
    expect(textbox2_2.placeholder).toBe('special(pregnancy)placeholder2');
    expect(textbox2_2.type).toBe('date');
    expect(textbox2_2).toBeDisabled();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Back Question', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 6, 
                title: "special(pregnancy)タイトル",
                shortTitle: "special(pregnancy)short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description1",
                    displayLeft: "special(pregnancy)displayLeft1",
                    displayName: "special(pregnancy)displayName1",
                    displayRight: "special(pregnancy)displayRight1",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "special(pregnancy)placeholder1",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description2",
                    displayLeft: "special(pregnancy)displayLeft2",
                    displayName: "special(pregnancy)displayName2",
                    displayRight: "special(pregnancy)displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(pregnancy)placeholder2",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 6, 
                questionNumber: 1, 
                shortTitle: "special(pregnancy)short2", 
                template_id: 1, 
                title: "special(pregnancy)タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description2-1",
                    displayLeft: "special(pregnancy)displayLeft2-1",
                    displayName: "special(pregnancy)displayName2-1",
                    displayRight: "special(pregnancy)displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(pregnancy)placeholder2-1",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description2-2",
                    displayLeft: "special(pregnancy)displayLeft2-2",
                    displayName: "special(pregnancy)displayName2-2",
                    displayRight: "special(pregnancy)displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(pregnancy)placeholder2-2",
                    options: []
                  }
                ]
              }
            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 6, 
                title: "special(pregnancy)タイトル",
                shortTitle: "special(pregnancy)short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description1",
                    displayLeft: "special(pregnancy)displayLeft1",
                    displayName: "special(pregnancy)displayName1",
                    displayRight: "special(pregnancy)displayRight1",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "special(pregnancy)placeholder1",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description2",
                    displayLeft: "special(pregnancy)displayLeft2",
                    displayName: "special(pregnancy)displayName2",
                    displayRight: "special(pregnancy)displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(pregnancy)placeholder2",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 6, 
                questionNumber: 1, 
                shortTitle: "special(pregnancy)short2", 
                template_id: 1, 
                title: "special(pregnancy)タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description2-1",
                    displayLeft: "special(pregnancy)displayLeft2-1",
                    displayName: "special(pregnancy)displayName2-1",
                    displayRight: "special(pregnancy)displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(pregnancy)placeholder2-1",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description2-2",
                    displayLeft: "special(pregnancy)displayLeft2-2",
                    displayName: "special(pregnancy)displayName2-2",
                    displayRight: "special(pregnancy)displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(pregnancy)placeholder2-2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    // それぞれのラジオボタンをクリックした時の動きをテストしてから、質問の行き来のテストを行う（ここではオプション1-3の選択状態で次の質問へ進む）
    const radio1_1 = screen.getAllByRole('radio', {name: "オプション1_1"})[0] as HTMLInputElement;
    const radio1_2 = screen.getAllByRole('radio', {name: "オプション1_2"})[0] as HTMLInputElement;
    const radio1_3 = screen.getAllByRole('radio', {name: "オプション1_3"})[0] as HTMLInputElement;
    const inputValue2_1 = screen.getAllByPlaceholderText('special(pregnancy)placeholder2')[0] as HTMLInputElement;

    // オプション1-1（いいえ）が選択された時は日付の入力ができない。また、日付入力欄のvalueが空になる。
    expect(radio1_1).not.toBeChecked();
    fireEvent.click(radio1_1);
    expect(radio1_1).toBeChecked();

    expect(inputValue2_1).toBeDisabled();
    expect(inputValue2_1.value).toBe('');

    // 日付入力ができたことを最後に確認したいので、オプション1-3のテストから行う
    // オプション1-3（可能性あり）が選択された時は日付の入力ができない。また、日付入力欄のvalueが空になる。
    expect(radio1_3).not.toBeChecked();
    fireEvent.click(radio1_3);
    expect(radio1_3).toBeChecked();

    expect(inputValue2_1).toBeDisabled();
    expect(inputValue2_1.value).toBe('');

    // オプション1-2（はい）が選択された時は日付の入力ができる。
    expect(radio1_2).not.toBeChecked();
    fireEvent.click(radio1_2);
    expect(radio1_2).toBeChecked();

    expect(inputValue2_1).not.toBeDisabled();
    inputValue2_1.focus();
    fireEvent.change(inputValue2_1, {target: {value: '2023-01-10'}});
    inputValue2_1.blur();
    expect(inputValue2_1.value).toBe('2023-01-10');

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(2/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.special(pregnancy)タイトル2"})).toBeInTheDocument();
    expect(screen.getAllByText('special(pregnancy)displayLeft2-2')[0]).toBeInTheDocument();

    // field
    const radio2_1 = screen.getAllByRole('radio', {name: "オプション2_1"})[0] as HTMLInputElement;
    expect(radio2_1.value ).toBe('1,オプション2_1');
    expect(radio2_1.type).toBe('radio');

    const radio2_2 = screen.getAllByRole('radio', {name: "オプション2_2"})[0] as HTMLInputElement;
    expect(radio2_2.value ).toBe('2,オプション2_2');
    expect(radio2_2.type).toBe('radio');

    const radio2_3 = screen.getAllByRole('radio', {name: "オプション2_3"})[0] as HTMLInputElement;
    expect(radio2_3.value ).toBe('3,オプション2_3');
    expect(radio2_3.type).toBe('radio');

    // field
    const textbox2_2 = screen.getAllByPlaceholderText('special(pregnancy)placeholder2-2')[0] as HTMLInputElement;
    
    expect(textbox2_2.value ).toBe('');
    expect(textbox2_2.placeholder).toBe('special(pregnancy)placeholder2-2');
    expect(textbox2_2.type).toBe('date');
    expect(textbox2_2).toBeDisabled(); // 何も選択されていない状態では数値入力欄はdisabledになっていること

    // button
    expect(screen.queryAllByText('戻る')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const backButton2 = screen.queryAllByText('戻る')[0];
    fireEvent.click(backButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.special(pregnancy)タイトル"})).toBeInTheDocument();
    expect(screen.getAllByText('special(pregnancy)displayLeft2')[0]).toBeInTheDocument();

    // field
    const backradio1_1 = screen.getAllByRole('radio', {name: "オプション1_1"})[0] as HTMLInputElement;
    expect(backradio1_1.value ).toBe('1,オプション1_1');
    expect(backradio1_1.type).toBe('radio');
    expect(backradio1_1).not.toBeChecked();

    const backradio1_2 = screen.getAllByRole('radio', {name: "オプション1_2"})[0] as HTMLInputElement;
    expect(backradio1_2.value ).toBe('2,オプション1_2');
    expect(backradio1_2.type).toBe('radio');
    expect(backradio1_2).toBeChecked();

    const backradio1_3 = screen.getAllByRole('radio', {name: "オプション1_3"})[0] as HTMLInputElement;
    expect(backradio1_3.value ).toBe('3,オプション1_3');
    expect(backradio1_3.type).toBe('radio');
    expect(backradio1_3).not.toBeChecked();

    // field
    const backtextbox2_2 = screen.getAllByPlaceholderText('special(pregnancy)placeholder2')[0] as HTMLInputElement;

    expect(backtextbox2_2.value ).toBe('2023-01-10');
    expect(backtextbox2_2.placeholder).toBe('special(pregnancy)placeholder2');
    expect(backtextbox2_2.type).toBe('date');
    expect(backtextbox2_2).not.toBeDisabled();


    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Confirmation', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 6, 
                title: "special(pregnancy)タイトル",
                shortTitle: "special(pregnancy)short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description1",
                    displayLeft: "special(pregnancy)displayLeft1",
                    displayName: "special(pregnancy)displayName1",
                    displayRight: "special(pregnancy)displayRight1",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "special(pregnancy)placeholder1",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description2",
                    displayLeft: "special(pregnancy)displayLeft2",
                    displayName: "special(pregnancy)displayName2",
                    displayRight: "special(pregnancy)displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(pregnancy)placeholder2",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 6, 
                questionNumber: 1, 
                shortTitle: "special(pregnancy)short2", 
                template_id: 1, 
                title: "special(pregnancy)タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description2-1",
                    displayLeft: "special(pregnancy)displayLeft2-1",
                    displayName: "special(pregnancy)displayName2-1",
                    displayRight: "special(pregnancy)displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(pregnancy)placeholder2-1",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description2-2",
                    displayLeft: "special(pregnancy)displayLeft2-2",
                    displayName: "special(pregnancy)displayName2-2",
                    displayRight: "special(pregnancy)displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(pregnancy)placeholder2-2",
                    options: []
                  }
                ]
              }
            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 6, 
                title: "special(pregnancy)タイトル",
                shortTitle: "special(pregnancy)short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description1",
                    displayLeft: "special(pregnancy)displayLeft1",
                    displayName: "special(pregnancy)displayName1",
                    displayRight: "special(pregnancy)displayRight1",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "special(pregnancy)placeholder1",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false},
                      {label: 'オプション1_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description2",
                    displayLeft: "special(pregnancy)displayLeft2",
                    displayName: "special(pregnancy)displayName2",
                    displayRight: "special(pregnancy)displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(pregnancy)placeholder2",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 6, 
                questionNumber: 1, 
                shortTitle: "special(pregnancy)short2", 
                template_id: 1, 
                title: "special(pregnancy)タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description2-1",
                    displayLeft: "special(pregnancy)displayLeft2-1",
                    displayName: "special(pregnancy)displayName2-1",
                    displayRight: "special(pregnancy)displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(pregnancy)placeholder2-1",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false},
                      {label: 'オプション2_3', value: '3', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(pregnancy)description2-2",
                    displayLeft: "special(pregnancy)displayLeft2-2",
                    displayName: "special(pregnancy)displayName2-2",
                    displayRight: "special(pregnancy)displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(pregnancy)placeholder2-2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const radio1_2 = screen.getAllByRole('radio', {name: "オプション1_2"})[0] as HTMLInputElement;
    expect(radio1_2).not.toBeChecked();
    fireEvent.click(radio1_2);
    expect(radio1_2).toBeChecked();

    const inputValue2_1 = screen.getAllByPlaceholderText('special(pregnancy)placeholder2')[0] as HTMLInputElement;

    // 2つ目の選択肢（radio1_2）を選択したので、日付入力欄が入力できることを確認
    expect(inputValue2_1).not.toBeDisabled();
    inputValue2_1.focus();
    fireEvent.change(inputValue2_1, {target: {value: '2023-01-10'}})
    inputValue2_1.blur();
    expect(inputValue2_1.value).toBe('2023-01-10');



    const nextButton1 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton1);

    const radio2_2 = screen.getAllByRole('radio', {name: "オプション2_2"})[0] as HTMLInputElement;
    expect(radio2_2).not.toBeChecked();
    fireEvent.click(radio2_2);
    expect(radio2_2).toBeChecked();

    const inputValue2_1_1 = screen.getAllByPlaceholderText('special(pregnancy)placeholder2-2')[0] as HTMLInputElement;

    // 2つ目の選択肢（radio2-2）を選択したので、日付入力欄が入力できなることを確認
    expect(inputValue2_1_1).not.toBeDisabled();
    inputValue2_1_1.focus();
    fireEvent.change(inputValue2_1_1, {target: {value: '2023-02-10'}})
    inputValue2_1_1.blur();
    expect(inputValue2_1_1.value).toBe('2023-02-10');


    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);


    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'special(pregnancy)short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'special(pregnancy)short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'オプション1_2'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '2023-01-10'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'オプション2_2'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '2023-02-10'})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();

    // 編集ボタン
    const editButton = screen.getByRole('link', {name: 'special(pregnancy)short'} );
    fireEvent.click(editButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.special(pregnancy)タイトル"})).toBeInTheDocument();
    expect(screen.getAllByText('special(pregnancy)displayLeft2')[0]).toBeInTheDocument();

    // field
    const backradio1_1 = screen.getAllByRole('radio', {name: "オプション1_1"})[0] as HTMLInputElement;
    expect(backradio1_1.value ).toBe('1,オプション1_1');
    expect(backradio1_1.type).toBe('radio');
    expect(backradio1_1).not.toBeChecked();

    const backradio1_2 = screen.getAllByRole('radio', {name: "オプション1_2"})[0] as HTMLInputElement;
    expect(backradio1_2.value ).toBe('2,オプション1_2');
    expect(backradio1_2.type).toBe('radio');
    expect(backradio1_2).toBeChecked();

    const backradio1_3 = screen.getAllByRole('radio', {name: "オプション1_3"})[0] as HTMLInputElement;
    expect(backradio1_3.value ).toBe('3,オプション1_3');
    expect(backradio1_3.type).toBe('radio');
    expect(backradio1_3).not.toBeChecked();

    // field
    const backtextbox2_2 = screen.getAllByPlaceholderText('special(pregnancy)placeholder2')[0] as HTMLInputElement;
    
    expect(backtextbox2_2).not.toBeDisabled();
    expect(backtextbox2_2.value ).toBe('2023-01-10');
    expect(backtextbox2_2.placeholder).toBe('special(pregnancy)placeholder2');
    expect(backtextbox2_2.type).toBe('date');


    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.getAllByText('確認画面へ')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const editradio1_1 = screen.getAllByRole('radio', {name: "オプション1_1"})[0] as HTMLInputElement;
    expect(editradio1_1).not.toBeChecked();
    fireEvent.click(editradio1_1);
    expect(editradio1_1).toBeChecked();

    const editinputValue2_1 = screen.getAllByPlaceholderText('special(pregnancy)placeholder2')[0] as HTMLInputElement;

    // 一つ目の選択肢（editradio1_1）を選択したので、日付入力欄が入力できないことを確認。また、valueが空になっていることを確認。
    expect(editinputValue2_1).toBeDisabled();
    expect(editinputValue2_1.value).toBe('');

    // 編集ボタン
    const confirmationButton = screen.getAllByText('確認画面へ')[0];
    fireEvent.click(confirmationButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'special(pregnancy)short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'special(pregnancy)short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'オプション1_1'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'オプション2_2'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '2023-02-10'})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();
  });    
});

describe('special moonage Test', () => {   
  test('Render', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 7, 
                title: "special(moonage)_タイトル",
                shortTitle: "special(moonage)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description1",
                    displayLeft: "special(moonage)_displayLeft1",
                    displayName: "special(moonage)_displayName1",
                    displayRight: "special(moonage)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "special(moonage)_placeholder1",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2",
                    displayLeft: "special(moonage)_displayLeft2",
                    displayName: "special(moonage)_displayName2",
                    displayRight: "special(moonage)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 7, 
                questionNumber: 1, 
                shortTitle: "special(moonage)_short2", 
                template_id: 1, 
                title: "special(moonage)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2-1",
                    displayLeft: "special(moonage)_displayLeft2-1",
                    displayName: "special(moonage)_displayName2-1",
                    displayRight: "special(moonage)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2-1",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2-2",
                    displayLeft: "special(moonage)_displayLeft2-2",
                    displayName: "special(moonage)_displayName2-2",
                    displayRight: "special(moonage)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2-2",
                    options: []
                  }
                ]
              }
            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 7, 
                title: "special(moonage)_タイトル",
                shortTitle: "special(moonage)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description1",
                    displayLeft: "special(moonage)_displayLeft1",
                    displayName: "special(moonage)_displayName1",
                    displayRight: "special(moonage)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "special(moonage)_placeholder1",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2",
                    displayLeft: "special(moonage)_displayLeft2",
                    displayName: "special(moonage)_displayName2",
                    displayRight: "special(moonage)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 7, 
                questionNumber: 1, 
                shortTitle: "special(moonage)_short2", 
                template_id: 1, 
                title: "special(moonage)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2-1",
                    displayLeft: "special(moonage)_displayLeft2-1",
                    displayName: "special(moonage)_displayName2-1",
                    displayRight: "special(moonage)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2-1",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2-2",
                    displayLeft: "special(moonage)_displayLeft2-2",
                    displayName: "special(moonage)_displayName2-2",
                    displayRight: "special(moonage)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2-2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.special(moonage)_タイトル"})).toBeInTheDocument();
    expect(screen.getAllByText('special(moonage)_displayLeft2')[0]).toBeInTheDocument();

    // field
    const radio1_1 = screen.getAllByRole('radio', {name: "オプション1_1"})[0] as HTMLInputElement;
    expect(radio1_1.value ).toBe('1,オプション1_1');
    expect(radio1_1.type).toBe('radio');

    const radio1_2 = screen.getAllByRole('radio', {name: "オプション1_2"})[0] as HTMLInputElement;
    expect(radio1_2.value ).toBe('2,オプション1_2');
    expect(radio1_2.type).toBe('radio');

    const textbox2_2 = screen.getAllByRole('spinbutton', {name: ""})[0] as HTMLInputElement;

    
    expect(textbox2_2.value ).toBe('');
    expect(textbox2_2.placeholder).toBe('special(moonage)_placeholder2');
    expect(textbox2_2.type).toBe('number');
    expect(textbox2_2).toBeDisabled();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Back Question', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 7, 
                title: "special(moonage)_タイトル",
                shortTitle: "special(moonage)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description1",
                    displayLeft: "special(moonage)_displayLeft1",
                    displayName: "special(moonage)_displayName1",
                    displayRight: "special(moonage)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "special(moonage)_placeholder1",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2",
                    displayLeft: "special(moonage)_displayLeft2",
                    displayName: "special(moonage)_displayName2",
                    displayRight: "special(moonage)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 7, 
                questionNumber: 1, 
                shortTitle: "special(moonage)_short2", 
                template_id: 1, 
                title: "special(moonage)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2-1",
                    displayLeft: "special(moonage)_displayLeft2-1",
                    displayName: "special(moonage)_displayName2-1",
                    displayRight: "special(moonage)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2-1",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2-2",
                    displayLeft: "special(moonage)_displayLeft2-2",
                    displayName: "special(moonage)_displayName2-2",
                    displayRight: "special(moonage)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2-2",
                    options: []
                  }
                ]
              }
            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 7, 
                title: "special(moonage)_タイトル",
                shortTitle: "special(moonage)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description1",
                    displayLeft: "special(moonage)_displayLeft1",
                    displayName: "special(moonage)_displayName1",
                    displayRight: "special(moonage)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "special(moonage)_placeholder1",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2",
                    displayLeft: "special(moonage)_displayLeft2",
                    displayName: "special(moonage)_displayName2",
                    displayRight: "special(moonage)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 7, 
                questionNumber: 1, 
                shortTitle: "special(moonage)_short2", 
                template_id: 1, 
                title: "special(moonage)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2-1",
                    displayLeft: "special(moonage)_displayLeft2-1",
                    displayName: "special(moonage)_displayName2-1",
                    displayRight: "special(moonage)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2-1",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2-2",
                    displayLeft: "special(moonage)_displayLeft2-2",
                    displayName: "special(moonage)_displayName2-2",
                    displayRight: "special(moonage)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2-2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    // それぞれのラジオボタンをクリックした時の動きをテストしてから、質問の行き来のテストを行う
    const radio1_1 = screen.getAllByRole('radio', {name: "オプション1_1"})[0] as HTMLInputElement;
    const radio1_2 = screen.getAllByRole('radio', {name: "オプション1_2"})[0] as HTMLInputElement;
    const inputValue2_1 = screen.getAllByRole('spinbutton', {name: ""})[0] as HTMLInputElement;

    // オプション1-1（いいえ）が選択された時は月齢入力欄に数値の入力ができない、valueが空になる
    expect(radio1_1).not.toBeChecked();
    fireEvent.click(radio1_1);
    expect(radio1_1).toBeChecked();

    expect(inputValue2_1).toBeDisabled();
    expect(inputValue2_1.value).toBe('');

    // オプション1-2（はい）が選択された時は月齢入力欄に数値の入力ができる
    expect(radio1_2).not.toBeChecked();
    fireEvent.click(radio1_2);
    expect(radio1_2).toBeChecked();

    expect(inputValue2_1).not.toBeDisabled();
    inputValue2_1.focus();
    fireEvent.change(inputValue2_1, {target: {value: '3'}}) // ここでは数値の範囲をテストしないが数値は適切なものを扱う
    inputValue2_1.blur();
    expect(inputValue2_1.value).toBe('3');

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);


    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(2/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.special(moonage)_タイトル2"})).toBeInTheDocument();
    expect(screen.getAllByText('special(moonage)_displayLeft2-2')[0]).toBeInTheDocument();

    // field
    const radio2_1 = screen.getAllByRole('radio', {name: "オプション2_1"})[0] as HTMLInputElement;
    expect(radio2_1.value ).toBe('1,オプション2_1');
    expect(radio2_1.type).toBe('radio');

    const radio2_2 = screen.getAllByRole('radio', {name: "オプション2_2"})[0] as HTMLInputElement;
    expect(radio2_2.value ).toBe('2,オプション2_2');
    expect(radio2_2.type).toBe('radio');

    // field
    const textbox2_2 = screen.getAllByRole('spinbutton', {name: ""})[0] as HTMLInputElement;
    
    expect(textbox2_2.value ).toBe('');
    expect(textbox2_2.placeholder).toBe('special(moonage)_placeholder2-2');
    expect(textbox2_2.type).toBe('number');
    expect(textbox2_2).toBeDisabled(); // 何も選択されていない状態では数値入力欄はdisabledになっていること


    // button
    expect(screen.queryAllByText('戻る')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const backButton2 = screen.queryAllByText('戻る')[0];
    fireEvent.click(backButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.special(moonage)_タイトル"})).toBeInTheDocument();
    expect(screen.getAllByText('special(moonage)_displayLeft2')[0]).toBeInTheDocument();

    // field
    const backradio1_1 = screen.getAllByRole('radio', {name: "オプション1_1"})[0] as HTMLInputElement;
    expect(backradio1_1.value ).toBe('1,オプション1_1');
    expect(backradio1_1.type).toBe('radio');
    expect(backradio1_1).not.toBeChecked();

    const backradio1_2 = screen.getAllByRole('radio', {name: "オプション1_2"})[0] as HTMLInputElement;
    expect(backradio1_2.value ).toBe('2,オプション1_2');
    expect(backradio1_2.type).toBe('radio');
    expect(backradio1_2).toBeChecked();

    // field
    const backtextbox2_2 = screen.getAllByRole('spinbutton', {name: ""})[0] as HTMLInputElement;

    
    expect(backtextbox2_2.value ).toBe('3');
    expect(backtextbox2_2.placeholder).toBe('special(moonage)_placeholder2');
    expect(backtextbox2_2.type).toBe('number');
    expect(backtextbox2_2).not.toBeDisabled();


    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Confirmation', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 7, 
                title: "special(moonage)_タイトル",
                shortTitle: "special(moonage)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description1",
                    displayLeft: "special(moonage)_displayLeft1",
                    displayName: "special(moonage)_displayName1",
                    displayRight: "special(moonage)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "special(moonage)_placeholder1",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2",
                    displayLeft: "special(moonage)_displayLeft2",
                    displayName: "special(moonage)_displayName2",
                    displayRight: "special(moonage)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 7, 
                questionNumber: 1, 
                shortTitle: "special(moonage)_short2", 
                template_id: 1, 
                title: "special(moonage)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2-1",
                    displayLeft: "special(moonage)_displayLeft2-1",
                    displayName: "special(moonage)_displayName2-1",
                    displayRight: "special(moonage)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2-1",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2-2",
                    displayLeft: "special(moonage)_displayLeft2-2",
                    displayName: "special(moonage)_displayName2-2",
                    displayRight: "special(moonage)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2-2",
                    options: []
                  }
                ]
              }
            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 7, 
                title: "special(moonage)_タイトル",
                shortTitle: "special(moonage)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description1",
                    displayLeft: "special(moonage)_displayLeft1",
                    displayName: "special(moonage)_displayName1",
                    displayRight: "special(moonage)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "special(moonage)_placeholder1",
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2",
                    displayLeft: "special(moonage)_displayLeft2",
                    displayName: "special(moonage)_displayName2",
                    displayRight: "special(moonage)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 7, 
                questionNumber: 1, 
                shortTitle: "special(moonage)_short2", 
                template_id: 1, 
                title: "special(moonage)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2-1",
                    displayLeft: "special(moonage)_displayLeft2-1",
                    displayName: "special(moonage)_displayName2-1",
                    displayRight: "special(moonage)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2-1",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2-2",
                    displayLeft: "special(moonage)_displayLeft2-2",
                    displayName: "special(moonage)_displayName2-2",
                    displayRight: "special(moonage)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2-2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const radio1_1 = screen.getAllByRole('radio', {name: "オプション1_1"})[0] as HTMLInputElement;
    expect(radio1_1).not.toBeChecked();
    fireEvent.click(radio1_1);
    expect(radio1_1).toBeChecked();

    const inputValue2_1 = screen.getAllByRole('spinbutton', {name: ""})[0] as HTMLInputElement;

    // 1つ目の選択肢（radio2_1_1）を選択したので、月齢入力欄に数値の入力はできない
    expect(inputValue2_1).toBeDisabled();

    const nextButton1 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton1);

    const radio2_1 = screen.getAllByRole('radio', {name: "オプション2_1"})[0] as HTMLInputElement;
    expect(radio2_1).not.toBeChecked();
    fireEvent.click(radio2_1);
    expect(radio2_1).toBeChecked();

    const inputValue2_1_1 = screen.getAllByRole('spinbutton', {name: ""})[0] as HTMLInputElement;

    // 1つ目の選択肢（radio2_1_1）を選択したので、月齢入力欄に数値の入力はできない
    expect(inputValue2_1_1).toBeDisabled();

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);


    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'special(moonage)_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'special(moonage)_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'オプション1_1'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'オプション2_1'})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();

    // 編集ボタン
    const editButton = screen.getByRole('link', {name: 'special(moonage)_short'} );
    fireEvent.click(editButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.special(moonage)_タイトル"})).toBeInTheDocument();
    expect(screen.getAllByText('special(moonage)_displayLeft2')[0]).toBeInTheDocument();

    // field
    const backradio1_1 = screen.getAllByRole('radio', {name: "オプション1_1"})[0] as HTMLInputElement;
    expect(backradio1_1.value ).toBe('1,オプション1_1');
    expect(backradio1_1.type).toBe('radio');
    expect(backradio1_1).toBeChecked();

    const backradio1_2 = screen.getAllByRole('radio', {name: "オプション1_2"})[0] as HTMLInputElement;
    expect(backradio1_2.value ).toBe('2,オプション1_2');
    expect(backradio1_2.type).toBe('radio');
    expect(backradio1_2).not.toBeChecked();

    // field
    const backtextbox2_2 = screen.getAllByRole('spinbutton', {name: ""})[0] as HTMLInputElement;
    
    expect(backtextbox2_2.value ).toBe('');
    expect(backtextbox2_2.placeholder).toBe('special(moonage)_placeholder2');
    expect(backtextbox2_2.type).toBe('number');
    expect(backtextbox2_2).toBeDisabled();


    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.getAllByText('確認画面へ')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const editradio1_2 = screen.getAllByRole('radio', {name: "オプション1_2"})[0] as HTMLInputElement;
    expect(editradio1_2).not.toBeChecked();
    fireEvent.click(editradio1_2);
    expect(editradio1_2).toBeChecked();

    const editinputValue2_1 = screen.getAllByRole('spinbutton', {name: ""})[0] as HTMLInputElement;

    // 二つ目の選択肢（editradio1_2）を選択したので、月齢入力欄に数値の入力ができる
    editinputValue2_1.focus();
    fireEvent.change(editinputValue2_1, {target: {value: '10'}})
    editinputValue2_1.blur();
    expect(editinputValue2_1.value).toBe('10');

    // 編集ボタン
    const confirmationButton = screen.getAllByText('確認画面へ')[0];
    fireEvent.click(confirmationButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'special(moonage)_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'special(moonage)_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'オプション1_2'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '10'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'オプション2_1'})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();
  });   
  
  test('Validation Check', async() => {
    global.alert = jest.fn()

    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] },
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 7, 
                title: "special(moonage)_タイトル",
                shortTitle: "special(moonage)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description1",
                    displayLeft: "special(moonage)_displayLeft1",
                    displayName: "special(moonage)_displayName1",
                    displayRight: "special(moonage)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "special(moonage)_placeholder1",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2",
                    displayLeft: "special(moonage)_displayLeft2",
                    displayName: "special(moonage)_displayName2",
                    displayRight: "special(moonage)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 7, 
                questionNumber: 1, 
                shortTitle: "special(moonage)_short2", 
                template_id: 1, 
                title: "special(moonage)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2-1",
                    displayLeft: "special(moonage)_displayLeft2-1",
                    displayName: "special(moonage)_displayName2-1",
                    displayRight: "special(moonage)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2-1",
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2-2",
                    displayLeft: "special(moonage)_displayLeft2-2",
                    displayName: "special(moonage)_displayName2-2",
                    displayRight: "special(moonage)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2-2",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: []
                  }
                ]
              }
            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 7, 
                title: "special(moonage)_タイトル",
                shortTitle: "special(moonage)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description1",
                    displayLeft: "special(moonage)_displayLeft1",
                    displayName: "special(moonage)_displayName1",
                    displayRight: "special(moonage)_displayRight1",
                    fieldDefaultValue: "",
                    formName: "radio",
                    placeholder: "special(moonage)_placeholder1",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: [
                      {label: 'オプション1_1', value: '1', is_option_clear: false},
                      {label: 'オプション1_2', value: '2', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2",
                    displayLeft: "special(moonage)_displayLeft2",
                    displayName: "special(moonage)_displayName2",
                    displayRight: "special(moonage)_displayRight2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 7, 
                questionNumber: 1, 
                shortTitle: "special(moonage)_short2", 
                template_id: 1, 
                title: "special(moonage)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2-1",
                    displayLeft: "special(moonage)_displayLeft2-1",
                    displayName: "special(moonage)_displayName2-1",
                    displayRight: "special(moonage)_displayRight2-1",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2-1",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: [
                      {label: 'オプション2_1', value: '1', is_option_clear: false},
                      {label: 'オプション2_2', value: '2', is_option_clear: false}
                    ]
                  },
                  {
                    dataTypeName: "etc",
                    description: "special(moonage)_description2-2",
                    displayLeft: "special(moonage)_displayLeft2-2",
                    displayName: "special(moonage)_displayName2-2",
                    displayRight: "special(moonage)_displayRight2-2",
                    fieldDefaultValue: "",
                    formName: "input",
                    placeholder: "special(moonage)_placeholder2-2",
                    validateValueMax: 999,
                    validateValueMin: 0,
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    // 2つ目の選択肢（はい）を選択した時のみ入力できる
    const radio1_2 = screen.getAllByRole('radio', {name: "オプション1_2"})[0] as HTMLInputElement;
    const inputValue2_1 = screen.getAllByRole('spinbutton', {name: ""})[0] as HTMLInputElement;

    // 2つ目の選択肢を選択して、月齢入力欄のバリデーションを確認
    expect(radio1_2).not.toBeChecked();
    fireEvent.click(radio1_2);
    expect(radio1_2).toBeChecked();

    expect(inputValue2_1).not.toBeDisabled();

    // 最小値は0、最大値は999を設定
    inputValue2_1.focus();
    fireEvent.change(inputValue2_1, {target: {value: '-1'}});
    inputValue2_1.blur();
    expect(global.alert).toHaveBeenCalledTimes(1);
    expect(inputValue2_1.value).toBe('');

    inputValue2_1.focus();
    fireEvent.change(inputValue2_1, {target: {value: '0'}});
    inputValue2_1.blur();
    expect(global.alert).toHaveBeenCalledTimes(1); // 範囲内の値を入力した時はインクリメントされないことを確認
    expect(inputValue2_1.value).toBe('0');

    inputValue2_1.focus();
    fireEvent.change(inputValue2_1, {target: {value: '1000'}});
    inputValue2_1.blur();
    expect(global.alert).toHaveBeenCalledTimes(2);
    expect(inputValue2_1.value).toBe('');

    inputValue2_1.focus();
    fireEvent.change(inputValue2_1, {target: {value: '999'}});
    inputValue2_1.blur();
    expect(global.alert).toHaveBeenCalledTimes(2); // 範囲内の値を入力した時はインクリメントされないことを確認
    expect(inputValue2_1.value).toBe('999');
  
  });
});

describe('Complate view Test', () => {  
  test('lend true', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: true,
            isEditMode: false,
            isRegistered: true,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(string)_タイトル",
                shortTitle: "input(string)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(string)_description",
                    displayLeft: "input(string)_displayLeft",
                    displayName: "input(string)_displayName",
                    displayRight: "input(string)_displayRight",
                    fieldDefaultValue: "input(string)_fieldDefaultValue",
                    formName: "input",
                    placeholder: "input(string)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(string)_short2", 
                template_id: 1, 
                title: "input(string)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(string)_description2",
                    displayLeft: "input(string)_displayLeft2",
                    displayName: "input(string)_displayName2",
                    displayRight: "input(string)_displayRight2",
                    fieldDefaultValue: "input(string)_fieldDefaultValue2",
                    formName: "input",
                    placeholder: "input(string)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(string)_タイトル",
                shortTitle: "input(string)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(string)_description",
                    displayLeft: "input(string)_displayLeft",
                    displayName: "input(string)_displayName",
                    displayRight: "input(string)_displayRight",
                    fieldDefaultValue: "input(string)_fieldDefaultValue",
                    formName: "input",
                    placeholder: "input(string)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(string)_short2", 
                template_id: 1, 
                title: "input(string)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(string)_description2",
                    displayLeft: "input(string)_displayLeft2",
                    displayName: "input(string)_displayName2",
                    displayRight: "input(string)_displayRight2",
                    fieldDefaultValue: "input(string)_fieldDefaultValue2",
                    formName: "input",
                    placeholder: "input(string)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);
    (axios.post as any).mockResolvedValue("");

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    expect(await screen.findByText('ご入力ありがとうございました。')).toBeInTheDocument();
    expect(await screen.findByText('この画面のまま、スタッフにご返却ください。')).toBeInTheDocument();
  });

  test('lend false', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: true,
            isEditMode: false,
            isRegistered: true,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(string)_タイトル",
                shortTitle: "input(string)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(string)_description",
                    displayLeft: "input(string)_displayLeft",
                    displayName: "input(string)_displayName",
                    displayRight: "input(string)_displayRight",
                    fieldDefaultValue: "input(string)_fieldDefaultValue",
                    formName: "input",
                    placeholder: "input(string)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(string)_short2", 
                template_id: 1, 
                title: "input(string)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(string)_description2",
                    displayLeft: "input(string)_displayLeft2",
                    displayName: "input(string)_displayName2",
                    displayRight: "input(string)_displayRight2",
                    fieldDefaultValue: "input(string)_fieldDefaultValue2",
                    formName: "input",
                    placeholder: "input(string)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(string)_タイトル",
                shortTitle: "input(string)_short", 
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(string)_description",
                    displayLeft: "input(string)_displayLeft",
                    displayName: "input(string)_displayName",
                    displayRight: "input(string)_displayRight",
                    fieldDefaultValue: "input(string)_fieldDefaultValue",
                    formName: "input",
                    placeholder: "input(string)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(string)_short2", 
                template_id: 1, 
                title: "input(string)_タイトル2",
                parts: [
                  {
                    dataTypeName: "etc",
                    description: "input(string)_description2",
                    displayLeft: "input(string)_displayLeft2",
                    displayName: "input(string)_displayName2",
                    displayRight: "input(string)_displayRight2",
                    fieldDefaultValue: "input(string)_fieldDefaultValue2",
                    formName: "input",
                    placeholder: "input(string)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);
    (axios.post as any).mockResolvedValue("");

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={false} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    expect(await screen.findByText('ご入力ありがとうございました')).toBeInTheDocument();
   
    const link = screen.getByRole('link', {name: '薬局活用ガイド 賢く薬局を活用するための情報をお届けしていきます。薬を安全に使うために、そして健康づくりのために、あなたにとって「良い薬局」を見つける役に立ちますように。'}) as HTMLAnchorElement
    expect(link.href).toBe('https://note.com/yakkyoku_guide/');
  });      
});


describe('Input(Phone) Test', () => {   
  test('Render', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(phone)_タイトル",
                shortTitle: "input(phone)_short", 
                parts: [
                  {
                    dataTypeName: "phone",
                    description: "input(phone)_description",
                    displayLeft: "input(phone)_displayLeft",
                    displayName: "input(phone)_displayName",
                    displayRight: "input(phone)_displayRight",
                    fieldDefaultValue: "input(phone)_fieldDefaultValue",
                    formName: "input_phone",
                    placeholder: "input(phone)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(phone)_short2", 
                template_id: 1, 
                title: "input(phone)_タイトル2",
                parts: [
                  {
                    dataTypeName: "phone",
                    description: "input(phone)_description2",
                    displayLeft: "input(phone)_displayLeft2",
                    displayName: "input(phone)_displayName2",
                    displayRight: "input(phone)_displayRight2",
                    fieldDefaultValue: "input(phone)_fieldDefaultValue2",
                    formName: "input_phone",
                    placeholder: "input(phone)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(phone)_タイトル",
                shortTitle: "input(phone)_short", 
                parts: [
                  {
                    dataTypeName: "phone",
                    description: "input(phone)_description",
                    displayLeft: "input(phone)_displayLeft",
                    displayName: "input(phone)_displayName",
                    displayRight: "input(phone)_displayRight",
                    fieldDefaultValue: "input(phone)_fieldDefaultValue",
                    formName: "input_phone",
                    placeholder: "input(phone)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(phone)_short2", 
                template_id: 1, 
                title: "input(phone)_タイトル2",
                parts: [
                  {
                    dataTypeName: "phone",
                    description: "input(phone)_description2",
                    displayLeft: "input(phone)_displayLeft2",
                    displayName: "input(phone)_displayName2",
                    displayRight: "input(phone)_displayRight2",
                    fieldDefaultValue: "input(phone)_fieldDefaultValue2",
                    formName: "input_phone",
                    placeholder: "input(phone)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.input(phone)_タイトル"})).toBeInTheDocument();
    expect(screen.getAllByText('input(phone)_displayLeft')[0]).toBeInTheDocument();
    expect(screen.getAllByText('input(phone)_displayRight')[0]).toBeInTheDocument();

    // field
    const textbox2 = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    expect(textbox2.value ).toBe('input(phone)_fieldDefaultValue');
    expect(textbox2.placeholder).toBe('input(phone)_placeholder');
    expect(textbox2.type).toBe('tel');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Back Question', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(phone)_タイトル",
                shortTitle: "input(phone)_short", 
                parts: [
                  {
                    dataTypeName: "phone",
                    description: "input(phone)_description",
                    displayLeft: "input(phone)_displayLeft",
                    displayName: "input(phone)_displayName",
                    displayRight: "input(phone)_displayRight",
                    fieldDefaultValue: "input(phone)_fieldDefaultValue",
                    formName: "input_phone",
                    placeholder: "input(phone)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(phone)_short2", 
                template_id: 1, 
                title: "input(phone)_タイトル2",
                parts: [
                  {
                    dataTypeName: "phone",
                    description: "input(phone)_description2",
                    displayLeft: "input(phone)_displayLeft2",
                    displayName: "input(phone)_displayName2",
                    displayRight: "input(phone)_displayRight2",
                    fieldDefaultValue: "input(phone)_fieldDefaultValue2",
                    formName: "input_phone",
                    placeholder: "input(phone)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(phone)_タイトル",
                shortTitle: "input(phone)_short", 
                parts: [
                  {
                    dataTypeName: "phone",
                    description: "input(phone)_description",
                    displayLeft: "input(phone)_displayLeft",
                    displayName: "input(phone)_displayName",
                    displayRight: "input(phone)_displayRight",
                    fieldDefaultValue: "input(phone)_fieldDefaultValue",
                    formName: "input_phone",
                    placeholder: "input(phone)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(phone)_short2", 
                template_id: 1, 
                title: "input(phone)_タイトル2",
                parts: [
                  {
                    dataTypeName: "phone",
                    description: "input(phone)_description2",
                    displayLeft: "input(phone)_displayLeft2",
                    displayName: "input(phone)_displayName2",
                    displayRight: "input(phone)_displayRight2",
                    fieldDefaultValue: "input(phone)_fieldDefaultValue2",
                    formName: "input_phone",
                    placeholder: "input(phone)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const inputValue = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: '08012341234'}})
    inputValue.blur();
    expect(inputValue.value).toBe('08012341234');

    

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(2/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.input(phone)_タイトル2"})).toBeInTheDocument();

    // main
    expect(screen.getAllByText('input(phone)_displayLeft2')[0]).toBeInTheDocument();
    expect(screen.getAllByText('input(phone)_displayRight2')[0]).toBeInTheDocument();

    // field
    const textbox2_2 = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    expect(textbox2_2.value).toBe('input(phone)_fieldDefaultValue2');
    expect(textbox2_2.placeholder).toBe('input(phone)_placeholder2');
    expect(textbox2_2.type).toBe('tel');

    // button
    expect(screen.queryAllByText('戻る')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const backButton2 = screen.queryAllByText('戻る')[0];
    fireEvent.click(backButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.input(phone)_タイトル"})).toBeInTheDocument();

    // main
    expect(screen.getAllByText('input(phone)_displayLeft')[0]).toBeInTheDocument();
    expect(screen.getAllByText('input(phone)_displayRight')[0]).toBeInTheDocument();

    // field
    const textbox2 = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;;
    expect(textbox2.value).toBe('08012341234');
    expect(textbox2.placeholder).toBe('input(phone)_placeholder');
    expect(textbox2.type).toBe('tel');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();
  
  });

  test('Confirmation', async() => {
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(phone)_タイトル",
                shortTitle: "input(phone)_short", 
                parts: [
                  {
                    dataTypeName: "phone",
                    description: "input(phone)_description",
                    displayLeft: "input(phone)_displayLeft",
                    displayName: "input(phone)_displayName",
                    displayRight: "input(phone)_displayRight",
                    fieldDefaultValue: "input(phone)_fieldDefaultValue",
                    formName: "input_phone",
                    placeholder: "input(phone)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(phone)_short2", 
                template_id: 1, 
                title: "input(phone)_タイトル2",
                parts: [
                  {
                    dataTypeName: "phone",
                    description: "input(phone)_description2",
                    displayLeft: "input(phone)_displayLeft2",
                    displayName: "input(phone)_displayName2",
                    displayRight: "input(phone)_displayRight2",
                    fieldDefaultValue: "input(phone)_fieldDefaultValue2",
                    formName: "input_phone",
                    placeholder: "input(phone)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(phone)_タイトル",
                shortTitle: "input(phone)_short", 
                parts: [
                  {
                    dataTypeName: "phone",
                    description: "input(phone)_description",
                    displayLeft: "input(phone)_displayLeft",
                    displayName: "input(phone)_displayName",
                    displayRight: "input(phone)_displayRight",
                    fieldDefaultValue: "input(phone)_fieldDefaultValue",
                    formName: "input_phone",
                    placeholder: "input(phone)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(phone)_short2", 
                template_id: 1, 
                title: "input(phone)_タイトル2",
                parts: [
                  {
                    dataTypeName: "phone",
                    description: "input(phone)_description2",
                    displayLeft: "input(phone)_displayLeft2",
                    displayName: "input(phone)_displayName2",
                    displayRight: "input(phone)_displayRight2",
                    fieldDefaultValue: "input(phone)_fieldDefaultValue2",
                    formName: "input_phone",
                    placeholder: "input(phone)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const inputValue = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: '08012341234'}})
    inputValue.blur();
    expect(inputValue.value).toBe('08012341234');

    const nextButton1 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton1);

    const inputValue2 = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    inputValue2.focus();
    fireEvent.change(inputValue2, {target: {value: '09012341234'}})
    inputValue2.blur();
    expect(inputValue2.value).toBe('09012341234');

    const nextButton2 = screen.queryAllByText('次へ')[0];
    fireEvent.click(nextButton2);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'input(phone)_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'input(phone)_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: '08012341234'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '09012341234'})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();

    // 編集ボタン
    const editButton = screen.getByRole('link', {name: 'input(phone)_short'} );
    fireEvent.click(editButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getByText('カテゴリ１')).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getByText('テスト患者2(1/2)')).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "Q.input(phone)_タイトル"})).toBeInTheDocument();
    expect(screen.getAllByText('input(phone)_displayLeft')[0]).toBeInTheDocument();
    expect(screen.getAllByText('input(phone)_displayRight')[0]).toBeInTheDocument();

    // field
    const textbox2 = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    expect(textbox2.value ).toBe('08012341234');
    expect(textbox2.placeholder).toBe('input(phone)_placeholder');
    expect(textbox2.type).toBe('tel');

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.getAllByText('確認画面へ')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('次へ')[0]).toBeInTheDocument();

    const editInputValue = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    editInputValue.focus();
    fireEvent.change(editInputValue, {target: {value: '07000000000'}})
    editInputValue.blur();
    expect(editInputValue.value).toBe('07000000000');

    // 編集ボタン
    const confirmationButton = screen.getAllByText('確認画面へ')[0];
    fireEvent.click(confirmationButton);

    // side
    expect(screen.getByText('テスト患者2 様')).toBeInTheDocument();
    expect(screen.getAllByText('カテゴリ１')[0]).toBeInTheDocument();

    // tag
    expect(screen.getByText('テスト患者(1/2)')).toBeInTheDocument();
    expect(screen.getAllByText('テスト患者2')[0]).toBeInTheDocument();

    // main
    expect(screen.getByRole('heading', {name: "登録内容の確認"})).toBeInTheDocument();

    // field
    expect(screen.getByRole('columnheader', {name: 'カテゴリ１'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: 'input(phone)_short'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: 'input(phone)_short2'})).toBeInTheDocument();

    expect(screen.getByRole('cell', {name: '07000000000'})).toBeInTheDocument();
    expect(screen.getByRole('cell', {name: '09012341234'})).toBeInTheDocument();

    // button
    expect(screen.queryByText('戻る')).toBeNull();
    expect(screen.queryByText('確認画面へ')).toBeNull();
    expect(screen.queryByText('次へ')).toBeNull();
    expect(screen.queryAllByText('登録')[0]).toBeInTheDocument();
  });    

  test('Validation Check', async() => {
    global.alert = jest.fn()
    const interviews = Promise.resolve({
      data: {
        categories: [
          {
            interviewDetailId: 1,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          },
          {
            interviewDetailId: 2,
            categories: [
              { partGroupId: 1, categoryName: 'カテゴリ１' }
            ]
          }
        ],
        interview_answers: [
          {
            interviewDetailId: 1,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          },
          {
            interviewDetailId: 2,
            isComplete: false,
            isEditMode: false,
            isRegistered: false,
            m_template_id: 1,
            questions: [
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 1 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
                
              },
              { 
                partGroupId: 1,
                answers: [
                  { partFieldId: 2 , value: '', label: '', arrValue: [], imgValue:[] }
                ],
              }
            ]
          }
        ],

        interview_contents: [
          {
            interviewDetailId: 1,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(phone)_タイトル",
                shortTitle: "input(phone)_short", 
                parts: [
                  {
                    dataTypeName: "phone",
                    description: "input(phone)_description",
                    displayLeft: "input(phone)_displayLeft",
                    displayName: "input(phone)_displayName",
                    displayRight: "input(phone)_displayRight",
                    fieldDefaultValue: "input(phone)_fieldDefaultValue",
                    formName: "input_phone",
                    placeholder: "input(phone)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(phone)_short2", 
                template_id: 1, 
                title: "input(phone)_タイトル2",
                parts: [
                  {
                    dataTypeName: "phone",
                    description: "input(phone)_description2",
                    displayLeft: "input(phone)_displayLeft2",
                    displayName: "input(phone)_displayName2",
                    displayRight: "input(phone)_displayRight2",
                    fieldDefaultValue: "input(phone)_fieldDefaultValue2",
                    formName: "input_phone",
                    placeholder: "input(phone)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          },
          {
            interviewDetailId: 2,
            interviewContents: [
              {
                questionNumber: 0,
                template_id: 1, 
                partGroupId: 1, 
                partKbn: 2, 
                title: "input(phone)_タイトル",
                shortTitle: "input(phone)_short", 
                parts: [
                  {
                    dataTypeName: "phone",
                    description: "input(phone)_description",
                    displayLeft: "input(phone)_displayLeft",
                    displayName: "input(phone)_displayName",
                    displayRight: "input(phone)_displayRight",
                    fieldDefaultValue: "input(phone)_fieldDefaultValue",
                    formName: "input_phone",
                    placeholder: "input(phone)_placeholder",
                    options: []
                  }
                ]
              },
              {
                partGroupId: 1, 
                partKbn: 2, 
                questionNumber: 1, 
                shortTitle: "input(phone)_short2", 
                template_id: 1, 
                title: "input(phone)_タイトル2",
                parts: [
                  {
                    dataTypeName: "phone",
                    description: "input(phone)_description2",
                    displayLeft: "input(phone)_displayLeft2",
                    displayName: "input(phone)_displayName2",
                    displayRight: "input(phone)_displayRight2",
                    fieldDefaultValue: "input(phone)_fieldDefaultValue2",
                    formName: "input_phone",
                    placeholder: "input(phone)_placeholder2",
                    options: []
                  }
                ]
              }

            ]
          }
        ],
        patients: [
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 1,
            patientId: 0,
            patientName: "テスト患者"
          },
          {
            currentQuestionNumber: 0,
            institutionId: 1,
            interviewDetailId: 2,
            patientId: 0,
            patientName: "テスト患者2"
          }
        ]
      }
    });
      
    (axios.get as any).mockResolvedValue(interviews);

    await act(() => interviews);
    act(() => {
      render(<Index interview_key='abc' is_lend={true} />);
    });

    expect(await screen.findByText('テスト患者')).toBeInTheDocument();
    
    const changePatient2 = screen.getByTestId("patient_2");
    fireEvent.click(changePatient2);

    const inputValue = screen.getByRole('textbox', {name: ""}) as HTMLInputElement;
    // 半角ハイフンあり -> 半角数字のみに変換されること　
    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: '080-1234-1234'}});
    inputValue.blur();
    expect(inputValue.value).toBe('08012341234');

    // 全角ハイフンなし -> 半角数字のみに変換されること
    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: '０８０１２３４１２３４'}});
    inputValue.blur();
    expect(inputValue.value).toBe('08012341234');

    // 全角ハイフンあり -> 半角数字のみに変換されること
    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: '０８０ー１２３４ー１２３４'}});
    inputValue.blur();
    expect(inputValue.value).toBe('08012341234');

    // 半角全角混じりハイフンなし -> 半角数字のみに変換されること
    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: '０8０1２3４1２3４'}});
    inputValue.blur();
    expect(inputValue.value).toBe('08012341234');

    // 半角全角混じりハイフンあり -> 半角数字のみに変換されること
    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: '０8０-1２3４ー1２3４'}})
    inputValue.blur();
    expect(inputValue.value).toBe('08012341234');

    // ハイフン2（―）
    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: '080―1234―1234'}})
    inputValue.blur();
    expect(inputValue.value).toBe('08012341234');

    // ハイフン3（‐）
    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: '080‐1234‐1234'}})
    inputValue.blur();
    expect(inputValue.value).toBe('08012341234');

    // ハイフン4（－）
    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: '080－1234－1234'}})
    inputValue.blur();
    expect(inputValue.value).toBe('08012341234');

    // ハイフン以外の記号があり、ハイフン削除処理後も半角数字のみにならない -> アラートが出る
    inputValue.focus();
    fireEvent.change(inputValue, {target: {value: '080*1234+1234'}})
    inputValue.blur();
    expect(global.alert).toHaveBeenCalledTimes(1);
    expect(inputValue.value).toBe('');
  });
});